import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Button,
  TextField,
  Paper,
  Alert,
  Collapse,
  IconButton,
  Card,
  CardContent,
  CircularProgress,
  Chip,
  Accordion,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Switch,
  FormControlLabel,
  AccordionSummary,
  AccordionDetails,
  Snackbar,
  InputAdornment,
  Tab,
  Tabs,
  Checkbox,
  ListItemText,
  Radio,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import EditIcon from '@mui/icons-material/Edit';
import RefreshIcon from '@mui/icons-material/Refresh';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CodeIcon from '@mui/icons-material/Code';
import SendIcon from '@mui/icons-material/Send';
import ImageIcon from '@mui/icons-material/Image';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import Tooltip from '@mui/material/Tooltip';
// Importer l'instance axios configurée avec les intercepteurs d'authentification
import api from '../../services/auth';
import { HIDE_INCOMPLETE_FEATURES, fetchLLMConfig } from '../../services/config';
import Autocomplete from '@mui/material/Autocomplete';
import EmailAssistant from '../../components/EmailAssistantNew';
import CampaignGraphBuilder from '../../components/CampaignGraphBuilder';
import {
  fetchWhatsappTemplates,
  fetchMauticContactsBySegment,
  launchWhatsappTemplateCampaign,
} from '../../services/inboxClient';

const steps = [
  "Objectif",
  "Cible",
  "Contenu",
  "Timing",
  "Workflow",
  "Résumé"
];

// Styles CSS personnalisés basés sur le template HTML
// SMS Preview Component (aligné sur la page TextMessages)
const SmsMockup = ({ message, timestamp = 'maintenant', image }) => (
  <Box sx={{
    width: '100%',
    maxWidth: 280,
    bgcolor: '#FFFFFF',
    borderRadius: 2,
    p: 2,
    boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)',
    border: '1px solid #E5E7EB',
  }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
      <Typography sx={{ fontSize: '0.7rem', fontWeight: 700, color: '#6B7280' }}>SMS</Typography>
      <Typography sx={{ fontSize: '0.7rem', color: '#6B7280' }}>{timestamp}</Typography>
    </Box>
    {image && (
      <Box
        component="img"
        src={image}
        sx={{
          width: '100%',
          borderRadius: 1,
          mb: 1,
          maxHeight: 200,
          objectFit: 'cover'
        }}
      />
    )}
    <Typography sx={{ fontSize: '0.85rem', color: '#111827', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
      {message || 'Votre message SMS apparaîtra ici...'}
    </Typography>
  </Box>
);

const customStyles = {
  root: {
    fontFamily: "'Source Sans 3', 'Inter', sans-serif",
    backgroundColor: '#f1f5f9',
    color: '#4B5563',
    minHeight: '100vh',
    padding: '1rem',
    '@media (min-width: 640px)': {
      padding: '2rem'
    }
  },
  container: {
    maxWidth: '80rem',
    margin: '0 auto',
    backgroundColor: 'white',
    borderRadius: '0.75rem',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  },
  header: {
    padding: '1.5rem',
    borderBottom: '1px solid #e2e8f0',
    '@media (min-width: 640px)': {
      padding: '2rem'
    }
  },
  headerTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#1f2937',
    margin: 0,
    fontFamily: "'Source Sans 3', 'Inter', sans-serif"
  },
  headerSubtitle: {
    marginTop: '0.25rem',
    color: '#6b7280',
    fontFamily: "'Source Sans 3', 'Inter', sans-serif"
  },
  navigation: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '0.5rem',
    padding: '1rem',
    borderBottom: '1px solid #e2e8f0',
    backgroundColor: '#f8fafc',
    '@media (min-width: 640px)': {
      gap: '1rem'
    }
  },
  stepButton: {
    position: 'relative',
    padding: '0.5rem 1.25rem',
    fontWeight: 500,
    color: '#6b7280',
    transition: 'all 0.3s ease',
    borderRadius: '9999px',
    fontSize: '0.9rem',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    fontFamily: "'Source Sans 3', 'Inter', sans-serif",
    '&.active': {
      color: '#fff',
      backgroundColor: '#007B8A'
    }
  },
  content: {
    padding: '1.5rem',
    '@media (min-width: 640px)': {
      padding: '2rem'
    }
  },
  stepTitle: {
    fontSize: '1.25rem',
    fontWeight: 500,
    color: '#1f2937',
    marginBottom: '1.25rem',
    fontFamily: "'Source Sans 3', 'Inter', sans-serif"
  },
  formInput: {
    width: '100%',
    border: '1px solid #e2e8f0',
    borderRadius: '0.5rem',
    padding: '0.75rem 1rem',
    transition: 'all 0.2s ease',
    fontFamily: "'Source Sans 3', sans-serif",
    '&:focus': {
      outline: 'none',
      borderColor: '#007B8A',
      boxShadow: '0 0 0 2px rgba(0, 123, 138, 0.15)'
    }
  },
  btn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.65rem 1.25rem',
    borderRadius: '0.5rem',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: 'none',
    fontFamily: "'Source Sans 3', sans-serif"
  },
  btnPrimary: {
    backgroundColor: '#007B8A',
    color: 'white',
    '&:hover': {
      backgroundColor: '#005D6B',
      transform: 'translateY(-1px)'
    }
  },
  btnSecondary: {
    backgroundColor: '#F1F5F9',
    color: '#4B5563',
    border: '1px solid #e2e8f0',
    '&:hover': {
      backgroundColor: '#E2E8F0'
    }
  },
  btnSuggest: {
    backgroundColor: '#10B981',
    color: 'white',
    '&:hover': {
      backgroundColor: '#059669'
    }
  },
  card: {
    backgroundColor: 'white',
    border: '1px solid #e2e8f0',
    borderRadius: '0.75rem',
    padding: '1.25rem'
  }
};

export default function PlanificationCampagne() {
  const location = useLocation();
  const navigate = useNavigate();
  const suggestions = location.state?.suggestions;
  const campaignName = location.state?.campaignName;

  const [activeStep, setActiveStep] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(true);
  const [segmentSuggestions, setSegmentSuggestions] = useState([]);
  const [emailSuggestions, setEmailSuggestions] = useState([]);
  const [isLoadingSegments, setIsLoadingSegments] = useState(false);
  const [loadingSegmentIds, setLoadingSegmentIds] = useState([]);
  const [isLoadingEmails, setIsLoadingEmails] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [mauticAvailable, setMauticAvailable] = useState(true);
  const [form, setForm] = useState({
    objectif: "",
    canal: "mautic_email", // Canal principal par défaut
    selectedContentTypes: ["email"], // Types de contenu sélectionnés : ['email', 'push']
    cible: "",
    selectedSegments: [],
    contenu: "",
    selectedEmails: [],
    loadingEmailIds: [], // Pour suivre les emails en cours de création
    selectedPushNotifications: [],
    loadingPushIds: [], // Pour suivre les notifications push en cours de création
    selectedSmsMessages: [], // messages (Facebook, WhatsApp, Instagram, SMS) sélectionnés
    loadingSmsIds: [], // Pour suivre les messages en cours de création
    timing: "",
    workflow: "",
    resume: "",
    useExistingSegment: false,
    useExistingEmail: false,
    startDate: '',
    endDate: '',
    isPublished: false,
    timezone: '+01:00',
    workflowDescription: '',
    campaignJson: null,
    visualGraph: null, // Graphique de l'éditeur visuel séparé
    workflowMode: HIDE_INCOMPLETE_FEATURES ? 'nl' : 'nl', // Mode par défaut pour les onglets du workflow
    useWhatsappTemplates: false,
    selectedWhatsappTemplateName: '',
    selectedWhatsappTemplateSegment: '',
  });

  // États pour les segments et emails existants dans Mautic
  const [existingSegments, setExistingSegments] = useState([]);
  const [existingEmails, setExistingEmails] = useState([]);
  const [isLoadingExistingSegments, setIsLoadingExistingSegments] = useState(false);
  const [isLoadingExistingEmails, setIsLoadingExistingEmails] = useState(false);
  const [segmentSearchText, setSegmentSearchText] = useState('');
  const [emailSearchText, setEmailSearchText] = useState('');
  const [pushSearchText, setPushSearchText] = useState('');
  const [filteredSegments, setFilteredSegments] = useState([]);
  const [filteredEmails, setFilteredEmails] = useState([]);
  const [filteredPushNotifications, setFilteredPushNotifications] = useState([]);
  const [pushSuggestions, setPushSuggestions] = useState([]);
  const [isLoadingPush, setIsLoadingPush] = useState(false);
  const [existingPushNotifications, setExistingPushNotifications] = useState([]);
  const [isLoadingExistingPush, setIsLoadingExistingPush] = useState(false);
  // SMS / Social messages states
  const [existingSmsMessages, setExistingSmsMessages] = useState([]);
  const [filteredSmsMessages, setFilteredSmsMessages] = useState([]);
  const [isLoadingExistingSms, setIsLoadingExistingSms] = useState(false);
  const [smsSearchText, setSmsSearchText] = useState('');
  const [smsSuggestions, setSmsSuggestions] = useState([]);
  // Loading IA par canal (évite d'afficher le spinner sur tous les boutons)
  const [smsLoadingByChannel, setSmsLoadingByChannel] = useState({
    facebook: false,
    whatsapp: false,
    instagram: false,
    sms: false,
  });
  // SMS edit modal
  const [smsEditModalOpen, setSmsEditModalOpen] = useState(false);
  const [smsToEdit, setSmsToEdit] = useState(null);
  const [smsEditFormData, setSmsEditFormData] = useState({ name: '', message: '', category: '' });
  const [smsEditPublished, setSmsEditPublished] = useState(true);
  const [smsEditImageUrl, setSmsEditImageUrl] = useState('');
  const [smsCategories, setSmsCategories] = useState([]);
  // États pour la galerie d'images Mautic (aligné sur TextMessages)
  const [smsAssetGalleryOpen, setSmsAssetGalleryOpen] = useState(false);
  const [smsAssetImages, setSmsAssetImages] = useState([]);
  const [smsAssetGalleryLoading, setSmsAssetGalleryLoading] = useState(false);
  const [smsAssetGalleryPage, setSmsAssetGalleryPage] = useState(1);
  const [smsAssetGalleryHasMore, setSmsAssetGalleryHasMore] = useState(true);
  const [smsSelectedAsset, setSmsSelectedAsset] = useState(null);
  const [isUpdatingSms, setIsUpdatingSms] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customCampaignName, setCustomCampaignName] = useState("");
  const [userCredentials, setUserCredentials] = useState({
    brand: "",
    mautic_url: "",
    mautic_username: "",
    mautic_password: ""
  });
  const [emailEditorOpen, setEmailEditorOpen] = useState(false);
  const [emailToEdit, setEmailToEdit] = useState(null);
  const [loadingWhatsappTemplates, setLoadingWhatsappTemplates] = useState(false);
  const [whatsappTemplates, setWhatsappTemplates] = useState([]);
  const [launchingWhatsappTemplateCampaign, setLaunchingWhatsappTemplateCampaign] = useState(false);

  // État initial de l'éditeur d'email (aligné sur la page Emails)
  const [emailEditorInitialMjml, setEmailEditorInitialMjml] = useState(null);
  const [emailEditorInitialBuilderJson, setEmailEditorInitialBuilderJson] = useState(null);
  const [emailEditorInitialLastMode, setEmailEditorInitialLastMode] = useState(null);
  const [emailEditorInitialHtmlEdited, setEmailEditorInitialHtmlEdited] = useState(false);
  const [emailEditorInitialHtmlSnapshot, setEmailEditorInitialHtmlSnapshot] = useState(null);
  const [emailEditorInitialDynamicContent, setEmailEditorInitialDynamicContent] = useState(null);
  const [emailEditorStateLoading, setEmailEditorStateLoading] = useState(false);
  const [emailEditorStateError, setEmailEditorStateError] = useState(null);

  // Push edit modal state
  const [pushEditModalOpen, setPushEditModalOpen] = useState(false);
  const [pushToEdit, setPushToEdit] = useState(null);
  const [pushEditFormData, setPushEditFormData] = useState({ name: '', message: '', url: '', buttonText: '' });
  const [isUpdatingPush, setIsUpdatingPush] = useState(false);

  // Référence pour le menu de sélection des segments
  const segmentSelectRef = React.useRef(null);
  const emailSelectRef = React.useRef(null);

  // Fonction pour gérer le changement de mode de workflow
  const handleWorkflowModeChange = (newMode) => {
    setForm(prev => {
      // Si on passe du mode visuel à NL, sauvegarder le graphique visuel
      if (prev.workflowMode === 'visual' && newMode === 'nl') {
        return {
          ...prev,
          workflowMode: newMode,
          visualGraph: prev.campaignJson || prev.visualGraph
        };
      }
      // Si on passe du mode NL au visuel, restaurer le graphique visuel
      else if (prev.workflowMode === 'nl' && newMode === 'visual') {
        return {
          ...prev,
          workflowMode: newMode,
          campaignJson: prev.visualGraph || prev.campaignJson
        };
      }
      // Sinon, juste changer le mode
      else {
        return {
          ...prev,
          workflowMode: newMode
        };
      }
    });
  };

  // Charger l'état avancé de l'éditeur pour un email donné (comme sur la page Emails)
  const loadEmailEditorState = async (emailId) => {
    if (!emailId) return;

    setEmailEditorStateLoading(true);
    setEmailEditorStateError(null);
    setEmailEditorInitialMjml(null);
    setEmailEditorInitialBuilderJson(null);
    setEmailEditorInitialLastMode(null);
    setEmailEditorInitialHtmlEdited(false);
    setEmailEditorInitialHtmlSnapshot(null);
    setEmailEditorInitialDynamicContent(null);

    try {
      const response = await api.get(`/emails/${emailId}/state`);
      if (response.data && response.data.success && response.data.state) {
        const state = response.data.state;
        setEmailEditorInitialMjml(state.mjml || null);
        setEmailEditorInitialBuilderJson(state.builderJson || null);
        setEmailEditorInitialLastMode(state.last_mode || null);
        setEmailEditorInitialHtmlEdited(Boolean(state.html_edited));
        setEmailEditorInitialHtmlSnapshot(state.html_snapshot || null);
        setEmailEditorInitialDynamicContent(state.dynamicContent || null);
      } else {
        setEmailEditorStateError(response.data?.message || "Impossible de charger l'état de l'éditeur.");
      }
    } catch (err) {
      console.error('[CAMPAIGN] Erreur chargement état éditeur email:', err);
      const msg = err?.response?.data?.message || err.message || "Erreur lors du chargement de l'état de l'éditeur.";
      setEmailEditorStateError(msg);
    } finally {
      setEmailEditorStateLoading(false);
    }
  };

  // Charger les segments et emails existants au chargement du composant
  // Charger les segments et emails existants au chargement du composant
  useEffect(() => {
    fetchUserCredentials();
    fetchExistingSegments();
    fetchExistingEmails();
    fetchExistingPushNotifications();
    fetchExistingSmsMessages();
  }, []);

  // Charger les catégories de messages (aligné sur TextMessages)
  useEffect(() => {
    (async () => {
      try {
        const resp = await api.get('/text-messages/categories');
        if (resp.data && resp.data.success) {
          setSmsCategories(resp.data.items || []);
        }
      } catch (e) {
        console.error('[PLAN] Error fetching SMS categories:', e);
      }
    })();
  }, []);

  // Réinitialiser la recherche de segments quand les segments changent
  useEffect(() => {
    setFilteredSegments(existingSegments);
  }, [existingSegments]);

  // Fonction pour récupérer les identifiants utilisateur depuis le backend
  const fetchUserCredentials = async () => {
    try {
      const response = await api.get('/auth/credentials');
      if (response.data.success && response.data.credentials) {
        setUserCredentials(response.data.credentials);
        setMauticAvailable(
          !!response.data.credentials.mautic_url &&
          !!response.data.credentials.mautic_username &&
          !!response.data.credentials.mautic_password
        );
      } else {
        setMauticAvailable(false);
      }
    } catch (err) {
      setMauticAvailable(false);
    }
  };

  // Fonction pour vérifier la disponibilité des credentials Mautic
  const checkMauticCredentials = () => {
    return userCredentials.mautic_url && userCredentials.mautic_username && userCredentials.mautic_password;
  };

  const isWhatsappTemplateMode = Boolean(form.useWhatsappTemplates && form.selectedContentTypes.includes('whatsapp'));
  const selectedWhatsappTemplate = whatsappTemplates.find((tpl) => tpl?.name === form.selectedWhatsappTemplateName) || null;
  const selectedWhatsappSegment = (form.selectedSegments || []).find((seg) => {
    const segValue = String(seg?.mautic_segment_id || seg?.id || seg?.name || '');
    return segValue === String(form.selectedWhatsappTemplateSegment || '');
  }) || null;

  function buildTemplateSendPayload(templateObj) {
    if (!templateObj?.name) return {};
    const languageCode = String(templateObj?.language || 'en');
    const hasFlowButton = Array.isArray(templateObj?.components)
      && templateObj.components.some(
        (comp) =>
          String(comp?.type || '').toUpperCase() === 'BUTTONS'
          && Array.isArray(comp?.buttons)
          && comp.buttons.some((b) => String(b?.type || '').toUpperCase() === 'FLOW'),
      );

    if (!hasFlowButton) {
      return {
        templateName: templateObj.name,
        templateLanguage: languageCode,
      };
    }

    return {
      templateName: templateObj.name,
      templateLanguage: languageCode,
      templateComponents: [
        {
          type: 'button',
          sub_type: 'flow',
          index: '0',
        },
      ],
    };
  }

  // Pré-remplir le formulaire avec les suggestions de l'IA si disponibles
  useEffect(() => {
    // Gère les suggestions reçues (tableau de chaînes) pour éviter les erreurs.
    if (suggestions && Array.isArray(suggestions) && suggestions.length > 0) {
      // Construit une chaîne de caractères à partir des suggestions pour l'objectif.
      const objectifText = "Optimisation de la campagne basée sur l'analyse IA des points suivants:\n- " + suggestions.join('\n- ');

      setForm(prev => ({
        ...prev,
        objectif: objectifText, // Pré-remplit l'objectif
        cible: "", // Réinitialise les champs dépendants
        workflow: "Workflow à définir basé sur les recommandations.",
        contenu: "",
        timing: "",
      }));
    }
    // Si 'suggestions' n'est pas un tableau valide, ne fait rien pour éviter un crash.
  }, [suggestions]);

  useEffect(() => {
    let cancelled = false;
    async function loadWhatsappTemplates() {
      if (!isWhatsappTemplateMode || !userCredentials?.brand) {
        setWhatsappTemplates([]);
        return;
      }
      setLoadingWhatsappTemplates(true);
      try {
        const list = await fetchWhatsappTemplates({ brand: userCredentials.brand });
        if (cancelled) return;
        setWhatsappTemplates(Array.isArray(list) ? list : []);
      } catch (e) {
        if (cancelled) return;
        setWhatsappTemplates([]);
        setError(e?.message || String(e));
      } finally {
        if (!cancelled) setLoadingWhatsappTemplates(false);
      }
    }
    loadWhatsappTemplates();
    return () => {
      cancelled = true;
    };
  }, [isWhatsappTemplateMode, userCredentials?.brand]);

  useEffect(() => {
    if (!isWhatsappTemplateMode) return;
    if (!(form.selectedSegments || []).length) {
      if (form.selectedWhatsappTemplateSegment) {
        setForm((prev) => ({ ...prev, selectedWhatsappTemplateSegment: '' }));
      }
      return;
    }
    const stillSelected = (form.selectedSegments || []).some((seg) => {
      const segValue = String(seg?.mautic_segment_id || seg?.id || seg?.name || '');
      return segValue === String(form.selectedWhatsappTemplateSegment || '');
    });
    if (!stillSelected) {
      const fallbackSegment = form.selectedSegments[0];
      const fallbackValue = String(fallbackSegment?.mautic_segment_id || fallbackSegment?.id || fallbackSegment?.name || '');
      setForm((prev) => ({ ...prev, selectedWhatsappTemplateSegment: fallbackValue }));
    }
  }, [isWhatsappTemplateMode, form.selectedSegments, form.selectedWhatsappTemplateSegment]);

  useEffect(() => {
    if (!isWhatsappTemplateMode) return;
    const workflowText = selectedWhatsappTemplate && selectedWhatsappSegment
      ? `Campagne WhatsApp Template:\n- Segment: ${selectedWhatsappSegment.name}\n- Template: ${selectedWhatsappTemplate.name}\n- Déclenchement: envoi direct via module Discussions (pas de création Mautic).`
      : '';
    setForm((prev) => ({
      ...prev,
      workflow: workflowText,
      campaignJson: workflowText ? { type: 'whatsapp_template_campaign' } : null,
      visualGraph: null,
    }));
  }, [isWhatsappTemplateMode, selectedWhatsappTemplate, selectedWhatsappSegment]);

  // Fonction pour récupérer les segments existants depuis Mautic
  const fetchExistingSegments = async () => {
    setIsLoadingExistingSegments(true);
    setError('');

    try {
      const response = await api.get('/campaigns/segments');

      if (response.data.success && response.data.segments) {
        // Tri des segments par date de création (du plus récent au moins récent)
        const sortedSegments = [...response.data.segments].sort((a, b) => {
          const dateA = new Date(a.dateAdded || a.dateModified || 0);
          const dateB = new Date(b.dateAdded || b.dateModified || 0);
          return dateB - dateA; // Ordre décroissant (plus récent en premier)
        });

        setExistingSegments(sortedSegments);
        setFilteredSegments(sortedSegments);
        setMauticAvailable(true);
      } else {
        if (response.data.message && response.data.message.includes('Mautic integration is not available')) {
          setMauticAvailable(false);
        }
      }
    } catch (err) {
      if (err.message && err.message.includes('MAUTIC_USERNAME is not set')) {
        setMauticAvailable(false);
      }
    } finally {
      setIsLoadingExistingSegments(false);
    }
  };

  // Fonction pour récupérer les templates d'email existants depuis Mautic
  const fetchExistingEmails = async () => {
    setIsLoadingExistingEmails(true);
    setError('');

    try {
      const response = await api.get('/campaigns/email-templates');

      if (response.data.success && response.data.templates) {
        // Tri des templates par date de création (du plus récent au moins récent)
        const sortedEmails = [...response.data.templates].sort((a, b) => {
          const dateA = new Date(a.dateAdded || a.dateModified || 0);
          const dateB = new Date(b.dateAdded || b.dateModified || 0);
          return dateB - dateA; // Ordre décroissant (plus récent en premier)
        });

        setExistingEmails(sortedEmails);
        setFilteredEmails(sortedEmails);
        setMauticAvailable(true);
      } else {
        if (response.data.message && response.data.message.includes('Mautic integration is not available')) {
          setMauticAvailable(false);
        }
      }
    } catch (err) {
      if (err.message && err.message.includes('MAUTIC_USERNAME is not set')) {
        setMauticAvailable(false);
      }
    } finally {
      setIsLoadingExistingEmails(false);
    }
  };

  // Fonction pour rechercher parmi les segments existants
  const handleSegmentSearch = (e) => {
    const searchValue = e.target.value;
    setSegmentSearchText(searchValue);

    // Filtrer immédiatement en fonction de la saisie
    if (!searchValue.trim()) {
      setFilteredSegments(existingSegments);
    } else {
      const filtered = existingSegments.filter(segment =>
        segment.name.toLowerCase().includes(searchValue.toLowerCase()) ||
        (segment.description && segment.description.toLowerCase().includes(searchValue.toLowerCase()))
      );
      setFilteredSegments(filtered);
    }
  };

  // Fonction pour rechercher parmi les templates d'email existants
  const handleEmailSearch = (e) => {
    const searchValue = e.target.value;
    setEmailSearchText(searchValue);

    if (!searchValue.trim()) {
      setFilteredEmails(existingEmails);
      return;
    }

    const filtered = existingEmails.filter(email =>
      email.name.toLowerCase().includes(searchValue.toLowerCase()) ||
      (email.subject && email.subject.toLowerCase().includes(searchValue.toLowerCase()))
    );

    setFilteredEmails(filtered);
  };

  // Fonction pour récupérer les notifications push existantes depuis Mautic
  const fetchExistingPushNotifications = async () => {
    setIsLoadingExistingPush(true);

    try {
      const response = await api.get('/push-notifications');

      if (response.data.notifications) {
        // Tri par date de création, similaire aux emails
        const sortedPush = [...response.data.notifications].sort((a, b) => {
          const dateA = new Date(a.dateAdded || a.dateModified || 0);
          const dateB = new Date(b.dateAdded || b.dateModified || 0);
          return dateB - dateA;
        });

        setExistingPushNotifications(sortedPush);
        setFilteredPushNotifications(sortedPush);
      }
    } catch (err) {
      console.error("Erreur récupération notifications:", err);
    } finally {
      setIsLoadingExistingPush(false);
    }
  };

  // Fonction pour rechercher parmi les notifications push existantes
  const handlePushSearch = (e) => {
    const searchValue = e.target.value;
    setPushSearchText(searchValue);

    if (!searchValue.trim()) {
      setFilteredPushNotifications(existingPushNotifications);
      return;
    }

    const filtered = existingPushNotifications.filter(push =>
      (push.name && push.name.toLowerCase().includes(searchValue.toLowerCase())) ||
      (push.message && push.message.toLowerCase().includes(searchValue.toLowerCase())) ||
      (push.heading && push.heading.toLowerCase().includes(searchValue.toLowerCase()))
    );

    setFilteredPushNotifications(filtered);
  };

  // ── SMS / Social Messages ────────────────────────────────────────────────────

  const fetchExistingSmsMessages = async () => {
    setIsLoadingExistingSms(true);
    try {
      const response = await api.get('/text-messages', { params: { page: 1, page_size: 100 } });
      const items = response.data?.items || response.data?.messages || [];
      const sorted = [...items].sort((a, b) => new Date(b.dateAdded || 0) - new Date(a.dateAdded || 0));
      setExistingSmsMessages(sorted);
      setFilteredSmsMessages(sorted);
    } catch (err) {
      console.error('[PLAN] Erreur chargement SMS:', err);
    } finally {
      setIsLoadingExistingSms(false);
    }
  };

  const handleSmsSearch = (value) => {
    setSmsSearchText(value);
    if (!value.trim()) {
      setFilteredSmsMessages(existingSmsMessages);
    } else {
      setFilteredSmsMessages(existingSmsMessages.filter(s =>
        (s.name || '').toLowerCase().includes(value.toLowerCase()) ||
        (s.message || s.text || '').toLowerCase().includes(value.toLowerCase())
      ));
    }
  };

  const suggestSmsMessages = async (channelType) => {
    if (!form.objectif.trim()) {
      setError('Veuillez définir un objectif avant de générer des messages');
      return;
    }
    setSmsLoadingByChannel(prev => ({ ...prev, [channelType]: true }));
    const channelLabel = { facebook: 'Facebook Messenger', whatsapp: 'WhatsApp', instagram: 'Instagram', sms: 'SMS' }[channelType] || channelType;
    try {
      const target = form.selectedSegments.length > 0
        ? form.selectedSegments.map(s => s.name).join(', ')
        : (form.cible || 'audience générale');
      const query = [
        `Objectif: ${form.objectif}`,
        `Canal: ${channelLabel}`,
        `Cible: ${target}`,
        `Consigne: Génère 3 à 5 messages courts et engageants pour ${channelLabel}. Chaque message doit être adapté au canal.`,
        `Format JSON attendu: [{ "name": "...", "message": "..." }]`,
        `La réponse DOIT être un JSON valide.`
      ].join('\n');

      const response = await api.post('/text-messages/generate', { query, category: channelType });

      if (response.data.success) {
        // Le backend peut retourner suggestions (liste) ou name/message (objet unique pour compat)
        let raw = [];
        if (Array.isArray(response.data.suggestions)) {
          raw = response.data.suggestions;
        } else if (response.data.message) {
          raw = [{
            name: response.data.name,
            message: response.data.message,
            category: response.data.category
          }];
        }

        const valid = raw.map(s => ({
          ...s,
          channelType,
          name: s.name || 'Message sans nom',
          message: s.message || s.text || ''
        }));

        // Conserver les suggestions des autres canaux (si plusieurs canaux sont activés)
        setSmsSuggestions(prev => [
          ...(Array.isArray(prev) ? prev.filter(p => p.channelType !== channelType) : []),
          ...valid
        ]);
        if (valid.length > 0) {
          setSuccess(`Messages ${channelLabel} générés avec succès`);
        } else {
          setError('Aucun message généré par l\'IA. Réessayez avec un objectif plus détaillé.');
        }
      } else {
        setError(response.data.message || 'Erreur lors de la génération des messages par l\'IA.');
      }
    } catch (err) {
      setError(err.response?.data?.detail || err.message || 'Erreur lors de la génération des messages');
    } finally {
      setSmsLoadingByChannel(prev => ({ ...prev, [channelType]: false }));
    }
  };

  const handleSelectSmsMessage = (sms) => {
    setForm(prev => {
      const isSelected = prev.selectedSmsMessages.some(s => s.name === sms.name && s.channelType === sms.channelType);
      return {
        ...prev,
        selectedSmsMessages: isSelected
          ? prev.selectedSmsMessages.filter(s => !(s.name === sms.name && s.channelType === sms.channelType))
          : [...prev.selectedSmsMessages, sms]
      };
    });
  };

  // Fonction pour charger les assets Mautic (aligné sur TextMessages)
  const loadSmsMauticAssets = async (page = 1) => {
    try {
      setSmsAssetGalleryLoading(true);
      const resp = await api.get('/emails/mautic/assets', {
        params: {
          limit: 30,
          start: (page - 1) * 30,
          orderBy: 'dateAdded',
          orderByDir: 'DESC',
        },
      });
      const data = resp?.data || {};
      const assetsObj = data.assets || {};
      const normalized = Object.values(assetsObj).map((asset) => ({
        id: asset.id,
        name: asset.title || asset.originalFileName || `Asset ${asset.id}`,
        url: asset.downloadUrl || asset.path || asset.url,
      }));
      if (data.total != null) {
        const totalPages = Math.ceil(Number(data.total || 0) / 30);
        setSmsAssetGalleryHasMore(page < totalPages);
      } else {
        setSmsAssetGalleryHasMore(normalized.length === 30);
      }
      return normalized;
    } catch (e) {
      console.error('[PLAN] Erreur chargement assets Mautic:', e);
      setError(e?.response?.data?.detail || e.message || "Erreur lors du chargement des images Mautic.");
      setSmsAssetGalleryHasMore(false);
      return [];
    } finally {
      setSmsAssetGalleryLoading(false);
    }
  };

  const handleOpenSmsAssetGallery = async () => {
    setSmsAssetGalleryOpen(true);
    setSmsAssetGalleryPage(1);
    const assets = await loadSmsMauticAssets(1);
    setSmsAssetImages(assets);
  };

  const handleLoadMoreSmsAssets = async () => {
    if (!smsAssetGalleryHasMore || smsAssetGalleryLoading) return;
    const nextPage = smsAssetGalleryPage + 1;
    setSmsAssetGalleryPage(nextPage);
    const more = await loadSmsMauticAssets(nextPage);
    if (more && more.length > 0) {
      setSmsAssetImages((prev) => [...prev, ...more]);
    }
  };

  const handleSelectSmsAsset = (asset) => {
    setSmsSelectedAsset(asset);
    setSmsEditImageUrl(asset.url);
    setSmsAssetGalleryOpen(false);
  };

  const handleEditSmsInCampaign = (sms) => {
    if (!sms) return;
    setSmsToEdit(sms);
    const rawCategory = sms.category ?? sms.channelType ?? '';
    const normalizedCategory =
      rawCategory && typeof rawCategory === 'object'
        ? (rawCategory.id ?? rawCategory._id ?? rawCategory.title ?? rawCategory.name ?? '')
        : rawCategory;
    setSmsEditFormData({
      name: sms.name || '',
      message: sms.message || sms.text || '',
      category: normalizedCategory
    });
    setSmsEditPublished(sms.isPublished !== false);
    setSmsEditImageUrl('');
    setSmsSelectedAsset(null);

    // Si déjà un asset Mautic associé
    const assetId = sms.assetId || (sms.properties && sms.properties.assetId);
    if (assetId) {
      // Tenter de retrouver l'URL de l'image
      const cachedAsset = smsAssetImages.find(a => String(a.id) === String(assetId));
      if (cachedAsset) {
        setSmsSelectedAsset(cachedAsset);
        setSmsEditImageUrl(cachedAsset.url);
      } else {
        // Sinon, récupérer via l'API (même endpoint que sur la page TextMessages)
        api.get('/emails/mautic/assets', {
          params: { limit: 1, start: 0, search: `id:${assetId}` }
        }).then(resp => {
          const data = resp?.data || {};
          const assetsObj = data.assets || {};
          const assetList = Object.values(assetsObj);
          if (assetList.length > 0) {
            const asset = assetList[0];
            const url = asset.downloadUrl || asset.path || asset.url;
            if (url) {
              setSmsSelectedAsset({ id: asset.id, name: asset.title || asset.originalFileName || `Asset ${asset.id}`, url });
              setSmsEditImageUrl(url);
            }
          }
        }).catch(e => {
          console.warn('[PLAN] Impossible de charger l\'image de l\'asset:', e);
        });
      }
    }
    setSmsEditModalOpen(true);
  };

  const handleUpdateSmsInCampaign = async () => {
    if (!smsToEdit) return;
    const smsId = smsToEdit.id;
    if (!smsId) { setError('ID du message manquant.'); return; }
    setIsUpdatingSms(true);
    try {
      const normalizedCategory =
        smsEditFormData.category && typeof smsEditFormData.category === 'object'
          ? (smsEditFormData.category.id ?? smsEditFormData.category._id ?? null)
          : (smsEditFormData.category || null);

      // Aligner avec l'éditeur TextMessages: injecter l'ID d'asset dans le titre
      let name = (smsEditFormData.name || '').trim();
      if (smsSelectedAsset?.id) {
        const suffix = `(${smsSelectedAsset.id})`;
        const idRegex = /\(\d+\)$/;
        if (idRegex.test(name)) {
          name = name.replace(idRegex, suffix);
        } else {
          name = `${name} ${suffix}`.trim();
        }
      }

      const payload = {
        name,
        message: smsEditFormData.message,
        isPublished: smsEditPublished,
        category: normalizedCategory,
      };

      // Préserver certains champs comme dans la page TextMessages
      if (smsToEdit.language) payload.language = smsToEdit.language;
      if (smsToEdit.description) payload.description = smsToEdit.description;
      if (smsToEdit.publishUp) payload.publishUp = smsToEdit.publishUp;
      if (smsToEdit.publishDown) payload.publishDown = smsToEdit.publishDown;

      const response = await api.put(`/text-messages/${smsId}`, payload);
      if (response.data?.success) {
        setSuccess('Message mis à jour avec succès.');
        setSmsEditModalOpen(false);
        setForm(prev => ({
          ...prev,
          selectedSmsMessages: prev.selectedSmsMessages.map(s =>
            String(s.id) === String(smsId)
              ? { ...s, name: smsEditFormData.name, message: smsEditFormData.message }
              : s
          )
        }));
        fetchExistingSmsMessages();
      } else {
        setError(response.data?.message || 'Erreur lors de la mise à jour du message.');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur lors de la mise à jour du message.');
    } finally {
      setIsUpdatingSms(false);
    }
  };

  const createSelectedSms = async (sms) => {
    if (!sms) return;
    setForm(prev => ({ ...prev, loadingSmsIds: [...prev.loadingSmsIds, sms.name] }));
    try {
      const response = await api.post('/text-messages', {
        name: sms.name,
        message: sms.message || sms.text,
        isPublished: true,
        category: sms.category?.id || sms.category || sms.channelType || 'sms'
      });
      const apiData = response.data || {};
      const rawResult = apiData.data || apiData;

      let created = rawResult;

      if (rawResult && typeof rawResult === 'object') {
        // Case 1: Mautic returns a single SMS object or map under "sms"
        if (rawResult.sms && typeof rawResult.sms === 'object') {
          const smsObj = rawResult.sms;
          if (Array.isArray(smsObj)) {
            const first = smsObj[0];
            if (first && typeof first === 'object') {
              created = {
                ...first,
                id: String(first.id ?? first.sms_id ?? ''),
              };
            }
          } else {
            const [firstKey, firstVal] = Object.entries(smsObj)[0] || [];
            const val = (firstVal && typeof firstVal === 'object') ? firstVal : smsObj;
            created = {
              ...val,
              id: String(val.id ?? val.sms_id ?? firstKey ?? ''),
            };
          }
        }
        // Case 2: Mautic returns a collection under "smses"
        else if (rawResult.smses) {
          const smses = rawResult.smses;
          if (Array.isArray(smses)) {
            const first = smses[0];
            if (first && typeof first === 'object') {
              created = {
                ...first,
                id: String(first.id ?? first.sms_id ?? ''),
              };
            }
          } else if (smses && typeof smses === 'object') {
            const [firstKey, firstVal] = Object.entries(smses)[0] || [];
            if (firstVal && typeof firstVal === 'object') {
              created = {
                ...firstVal,
                id: String(firstVal.id ?? firstVal.sms_id ?? firstKey ?? ''),
              };
            }
          }
        }
      }

      const updated = { ...sms, ...created, isExisting: true };
      setForm(prev => {
        const idx = prev.selectedSmsMessages.findIndex(s => s.name === sms.name && s.channelType === sms.channelType);
        const list = [...prev.selectedSmsMessages];
        if (idx !== -1) list[idx] = updated; else list.push(updated);
        return { ...prev, selectedSmsMessages: list, loadingSmsIds: prev.loadingSmsIds.filter(id => id !== sms.name) };
      });
      setSuccess(`Message '${sms.name}' créé avec succès.`);
      fetchExistingSmsMessages();
      handleEditSmsInCampaign(updated);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur lors de la création du message.');
      setForm(prev => ({ ...prev, loadingSmsIds: prev.loadingSmsIds.filter(id => id !== sms.name) }));
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────

  const suggestPushNotifications = async () => {
    if (!form.objectif.trim()) {
      setError('Veuillez définir un objectif avant de générer des notifications push');
      return;
    }

    setIsLoadingPush(true);

    try {
      // Construct query
      const formattedQuery = [
        `Objectif: ${form.objectif}`,
        `Cible: ${form.cible || form.selectedSegments.map(s => s.name).join(', ')}`,
        "Consigne: Suggère 3 à 5 notifications push engageantes.",
        "Format JSON attendu (IMPORTANT): [{ \"name\": \"...\", \"heading\": \"...\", \"message\": \"...\" }]",
        "La réponse DOIT être un JSON valide."
      ].join('\n');

      const response = await api.post('/push-notifications/generate', {
        query: formattedQuery
      });

      if (response.data.success && response.data.suggestions && response.data.suggestions.length > 0) {
        // Ensure suggestions have required fields
        // Ensure suggestions have required fields, checking both top-level and config object
        const validSuggestions = response.data.suggestions.map(s => ({
          name: s.name || s.config?.name || "Nouvelle Notification",
          heading: s.config?.heading || s.heading || s.title || s.name || "Titre",
          message: s.config?.message || s.message || ""
        }));
        setPushSuggestions(validSuggestions);
        setSuccess(prev => prev ? `${prev} + Push générés` : 'Notifications Push générées avec succès');
      } else {
        // Handle explicit message or generics
        const msg = response.data.message || 'Aucune suggestion de push trouvée.';
        setError(prev => prev ? `${prev}\n${msg}` : msg);
      }
    } catch (err) {
      console.error('Erreur génération push:', err);
      // Avoid overwriting important errors if parallel requests
      const errMsg = err.response?.data?.detail || err.message || 'Échec de la génération des suggestions push.';
      setError(prev => prev ? `${prev}\n${errMsg}` : errMsg);
    } finally {
      setIsLoadingPush(false);
    }
  };

  const handleSelectPushNotification = (push) => {
    setForm(prev => {
      const isSelected = prev.selectedPushNotifications.some(p => p.name === push.name);
      let newSelectedPush;

      if (isSelected) {
        newSelectedPush = prev.selectedPushNotifications.filter(p => p.name !== push.name);
      } else {
        newSelectedPush = [...prev.selectedPushNotifications, push];
      }

      return {
        ...prev,
        selectedPushNotifications: newSelectedPush
      };
    });
  };

  // Open push edit modal (same form & endpoint as push page)
  const handleEditPushInCampaign = (push) => {
    if (!push) return;
    setPushToEdit(push);
    setPushEditFormData({
      name: push.name || push.heading || push.title || '',
      message: push.message || '',
      url: push.url || '',
      buttonText: push.button || push.actionButtonText || ''
    });
    setPushEditModalOpen(true);
  };

  // Update push notification (same endpoint as push page)
  const handleUpdatePushInCampaign = async () => {
    if (!pushToEdit) return;

    const pushId = pushToEdit.id;
    if (!pushId) {
      setError('Impossible de modifier cette notification : ID manquant.');
      return;
    }

    setIsUpdatingPush(true);
    try {
      const payload = {
        name: pushEditFormData.name || 'Notification Sans Nom',
        heading: pushEditFormData.name, // Use name as heading/title
        message: pushEditFormData.message,
        url: pushEditFormData.url,
        button: pushEditFormData.buttonText
      };

      const response = await api.put(`/push-notifications/${pushId}`, payload);

      if (response.data && response.data.notification) {
        setSuccess('Notification push mise à jour avec succès.');
        setPushEditModalOpen(false);

        // Update in selectedPushNotifications
        const updatedPush = response.data.notification;
        setForm(prev => {
          const updatedList = prev.selectedPushNotifications.map(p => {
            if (String(p.id) === String(pushId)) {
              return {
                ...p,
                name: updatedPush.name || pushEditFormData.name,
                heading: updatedPush.heading || pushEditFormData.name,
                message: updatedPush.message || pushEditFormData.message,
                url: updatedPush.url || pushEditFormData.url,
                button: updatedPush.button || pushEditFormData.buttonText
              };
            }
            return p;
          });
          return { ...prev, selectedPushNotifications: updatedList };
        });

        // Also refresh existing push list
        fetchExistingPushNotifications();
      }
    } catch (error) {
      console.error('Erreur mise à jour push:', error);
      setError(error.response?.data?.detail || 'Erreur lors de la mise à jour de la notification push.');
    } finally {
      setIsUpdatingPush(false);
    }
  };

  const createSelectedPush = async (pushToCreate) => {
    if (!pushToCreate) return;

    setForm(prev => ({
      ...prev,
      loadingPushIds: [...prev.loadingPushIds, pushToCreate.name]
    }));

    try {
      const response = await api.post('/push-notifications/new', {
        name: pushToCreate.name,
        heading: pushToCreate.heading,
        message: pushToCreate.message,
        isPublished: true
      });

      if (response.data.notification) {
        const createdPush = response.data.notification;
        // Update selected push with ID
        const updatedPush = { ...pushToCreate, ...createdPush, isExisting: true };

        setForm(prev => {
          const pushIndex = prev.selectedPushNotifications.findIndex(p => p.name === pushToCreate.name);
          const updatedList = [...prev.selectedPushNotifications];
          if (pushIndex !== -1) updatedList[pushIndex] = updatedPush;
          else updatedList.push(updatedPush); // Should be there, but fallback

          return {
            ...prev,
            selectedPushNotifications: updatedList,
            loadingPushIds: prev.loadingPushIds.filter(id => id !== pushToCreate.name)
          };
        });
        setSuccess(`Notification '${pushToCreate.name}' créée avec succès.`);
        // Refresh list to see the new one in "Templates"
        fetchExistingPushNotifications();
        handleEditPushInCampaign(updatedPush);
      }
    } catch (err) {
      console.error("Error creating push:", err);
      const errMsg = err.response?.data?.detail || "Erreur lors de la création de la notification push.";
      setError(errMsg);
      setForm(prev => ({
        ...prev,
        loadingPushIds: prev.loadingPushIds.filter(id => id !== pushToCreate.name)
      }));
    }
  };



  const suggestSegments = async () => {
    if (!form.objectif.trim()) {
      setError('Veuillez définir un objectif avant de générer des segments');
      return;
    }

    setIsLoadingSegments(true);
    setError('');
    setSegmentSuggestions([]);

    try {
      // Fetch LLM configuration from backend
      const llmConfig = await fetchLLMConfig();

      // Prompt concis focalisé sur les propriétés supportées pour réduire les timeouts
      const formattedQuery = [
        `Objectif: ${form.objectif}`,
        "Consigne: Suggère 3 à 5 segments en FRANÇAIS en utilisant UNIQUEMENT les champs existants du système. N'invente aucun champ.",
        "Chaque segment doit avoir: name, description, et une configuration Unomi valide basée sur ces champs."
      ].join('\n');

      // Use LLM configuration from backend
      const primaryReq = {
        query: formattedQuery,
        provider: llmConfig.provider,
        model: llmConfig.model,
        includeExisting: true
      };

      let response = await api.post('/segments/suggest', primaryReq);

      if (response?.data?.success && Array.isArray(response.data.suggestions) && response.data.suggestions.length > 0) {
        const formattedSuggestions = response.data.suggestions.map(suggestion => ({
          ...suggestion,
          isExisting: suggestion.mautic_segment_id ? true : false
        }));
        setSegmentSuggestions(formattedSuggestions);
        setSuccess('Segments suggérés générés avec succès');
        setMauticAvailable(!response.data.message?.includes('Mautic integration is not available'));
      } else {
        setError(response?.data?.message || "Aucune suggestion de segment trouvée. Précisez l'objectif avec des critères mesurables (ex: inactifs > 90 jours, pays = FR).");
      }
    } catch (err) {
      setError(err.message || 'Échec de la génération des suggestions de segments. Veuillez réessayer avec un objectif plus détaillé.');
      if (err.message && err.message.includes('MAUTIC_USERNAME is not set')) {
        setMauticAvailable(false);
      }
    } finally {
      setIsLoadingSegments(false);
    }
  };

  // Fonction pour sélectionner ou désélectionner un segment
  const handleSelectSegment = (segment) => {
    setForm(prev => {
      const isSelected = prev.selectedSegments.some(s => s.name === segment.name);
      let newSelectedSegments;

      if (isSelected) {
        // Désélectionner le segment
        newSelectedSegments = prev.selectedSegments.filter(s => s.name !== segment.name);
      } else {
        // Sélectionner le segment
        newSelectedSegments = [...prev.selectedSegments, segment];
      }

      return {
        ...prev,
        selectedSegments: newSelectedSegments,
        useExistingSegment: false
      };
    });
  };

  // La fonction handleSelectExistingSegment est déjà définie plus haut dans le code

  // Fonction pour sélectionner ou désélectionner un email
  const handleSelectEmail = (email) => {
    setForm(prev => {
      const isSelected = prev.selectedEmails.some(e => e.name === email.name);
      let newSelectedEmails;

      if (isSelected) {
        // Désélectionner l'email
        newSelectedEmails = prev.selectedEmails.filter(e => e.name !== email.name);
      } else {
        // Sélectionner l'email
        newSelectedEmails = [...prev.selectedEmails, email];
      }

      return {
        ...prev,
        selectedEmails: newSelectedEmails
      };
    });
  };

  // La fonction handleSelectExistingEmail est déjà définie plus haut dans le code

  // Gestion du changement de fuseau horaire
  const handleTimezoneChange = (e) => {
    setForm(prev => ({
      ...prev,
      timezone: e.target.value
    }));
  };

  // Formater une date pour Mautic
  const formatDateForMautic = (dateTimeValue) => {
    if (!dateTimeValue) return '';
    return dateTimeValue.replace('T', ' ') + ':00';
  };

  // Fonction pour ajuster la date en fonction du fuseau horaire
  const adjustDateForTimezone = (dateTimeValue, timezone) => {
    if (!dateTimeValue) return '';
    try {
      // Normaliser la valeur de date vers ISO-like (YYYY-MM-DDTHH:MM:SS)
      let normalized = dateTimeValue;
      if (dateTimeValue.includes(' ')) normalized = dateTimeValue.replace(' ', 'T');
      if (!normalized.includes('T')) normalized = `${normalized}T00:00:00`;

      const localDate = new Date(normalized);
      if (isNaN(localDate.getTime())) {
        return dateTimeValue;
      }

      // Calculer l'offset en minutes à partir de "UTC", "+HH:MM" ou "-HH:MM". Pour les autres valeurs, on suppose UTC.
      let offsetMinutes = 0;
      if (timezone && /^([+-])(\d{2}):(\d{2})$/.test(timezone)) {
        const [, sign, hh, mm] = timezone.match(/^([+-])(\d{2}):(\d{2})$/) || [];
        const minutes = parseInt(hh, 10) * 60 + parseInt(mm, 10);
        offsetMinutes = sign === '-' ? -minutes : minutes;
      } else if (timezone === 'UTC') {
        offsetMinutes = 0;
      } else if (typeof timezone === 'string' && timezone.startsWith('+') || timezone.startsWith('-')) {
        // Fallback simple pour formats comme +01:00 (déjà couvert) ou +01
        const hours = parseInt(timezone, 10);
        offsetMinutes = isNaN(hours) ? 0 : hours * 60;
      } else {
        // Non géré (ex: Europe/Paris) -> fallback UTC
        offsetMinutes = 0;
      }

      // Convertir l'heure locale saisie vers UTC attendu par backend: UTC = local - offset
      const utcMs = localDate.getTime() - offsetMinutes * 60 * 1000;
      const utcDate = new Date(utcMs);

      const pad = (num) => String(num).padStart(2, '0');
      const formatted = `${utcDate.getUTCFullYear()}-${pad(utcDate.getUTCMonth() + 1)}-${pad(utcDate.getUTCDate())} ${pad(utcDate.getUTCHours())}:${pad(utcDate.getUTCMinutes())}:00`;
      return formatted;
    } catch (err) {
      return dateTimeValue;
    }
  };

  // Format helper for displaying dates nicely in FR from 'YYYY-MM-DD HH:MM:SS'
  const formatDisplayDate = (dateTimeValue) => {
    if (!dateTimeValue) return '';
    try {
      const normalized = dateTimeValue.includes('T') ? dateTimeValue : dateTimeValue.replace(' ', 'T');
      const d = new Date(normalized);
      if (isNaN(d.getTime())) return dateTimeValue;
      return d.toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' });
    } catch {
      return dateTimeValue;
    }
  };

  // Construit une description narrative détaillée à partir d'un JSON de campagne
  const buildWorkflowNarrative = (campaignData) => {
    try {
      if (!campaignData) return '';
      // Supporte deux schémas: { campaign: {...} } ou top-level {...}
      const c = campaignData.campaign || campaignData;
      const lines = [];

      if (c.name) {
        lines.push(`Campagne: ${c.name}`);
      }

      if (c.publishUp || c.publishDown) {
        const start = c.publishUp ? formatDisplayDate(c.publishUp) : 'Non défini';
        const end = c.publishDown ? formatDisplayDate(c.publishDown) : 'Non définie';
        lines.push(`Période: Début ${start} • Fin ${end}`);
      }

      const events = Array.isArray(c.events) ? c.events : [];
      if (events.length === 0) return lines.join('\n');

      events.forEach((event, index) => {
        const stepTitle = `Étape ${index + 1}`;
        const stepLines = [];

        const eventName = event.name || event.type || 'Événement';
        stepLines.push(`${eventName}`);

        // Info supplémentaire pour les notifications push
        if (event.type === 'notification.send_notification') {
          const pushId = event.properties?.notification || event.channelId || '';
          stepLines.push(`Type: Notification push${pushId ? ` (ID: ${pushId})` : ''}`);
        }

        // Info supplémentaire pour les messages (SMS / Text Messages)
        if (event.type === 'sms.send_text_sms') {
          const smsId =
            event.properties?.sms ||
            event.properties?.properties?.sms ||
            event.channelId ||
            '';
          stepLines.push(`Type: Message (SMS)${smsId ? ` (ID: ${smsId})` : ''}`);
        }

        // Timing/trigger
        if (event.timing && event.timing.type) {
          if (event.timing.type === 'interval') {
            const unit = event.timing.unit || 'jours';
            stepLines.push(`Timing: Attente de ${event.timing.interval} ${unit}`);
          } else if (event.timing.type === 'date') {
            stepLines.push(`Timing: À la date ${formatDisplayDate(event.timing.date)}`);
          } else if (event.timing.type === 'immediate') {
            stepLines.push('Timing: Exécution immédiate');
          }
        } else if (event.triggerMode === 'date' && event.triggerDate) {
          stepLines.push(`Timing: Déclenchement le ${formatDisplayDate(event.triggerDate)}`);
        }

        // Conditions
        if (Array.isArray(event.conditions) && event.conditions.length > 0) {
          const conds = event.conditions.map((cond) => cond.description || cond.type || 'Condition').join(', ');
          stepLines.push(`Conditions: ${conds}`);
        }

        // Actions
        if (Array.isArray(event.actions) && event.actions.length > 0) {
          const actionDescriptions = event.actions.map((a) => {
            const label = a.description || a.type || 'Action';
            if (a.type === 'sendEmail' && a.emailName) {
              return `Envoi de l'email « ${a.emailName} »`;
            }
            // Supporte typages alternatifs
            if ((a.type === 'email.send' || a.type === 'emailSend') && (a.emailName || a.email || a.name)) {
              return `Envoi de l'email « ${a.emailName || a.email || a.name} »`;
            }
            if (a.type === 'addToSegment' && a.segmentName) {
              return `Ajout au segment « ${a.segmentName} »`;
            }
            if (a.type === 'removeFromSegment' && a.segmentName) {
              return `Retrait du segment « ${a.segmentName} »`;
            }
            if ((a.type === 'emailOpened' || a.type === 'openCondition') && a.emailName) {
              return `Décision: email « ${a.emailName} » ouvert`;
            }
            if ((a.type === 'emailClicked' || a.type === 'clickCondition') && a.emailName) {
              return `Décision: clic dans l'email « ${a.emailName} »`;
            }
            return label;
          });
          stepLines.push(`Actions: ${actionDescriptions.join('; ')}`);
        }

        // Branches courantes (si le schéma les expose)
        if (Array.isArray(event.branches) && event.branches.length > 0) {
          const branches = event.branches.map((b) => {
            const name = b.name || b.type || 'Branche';
            if (b.condition) {
              const cond = b.condition.description || b.condition.type || 'condition';
              return `${name}: ${cond}`;
            }
            return name;
          });
          stepLines.push(`Branches: ${branches.join(' | ')}`);
        }

        lines.push(`${stepTitle}:\n${stepLines.join('\n')}`);
      });

      return lines.join('\n\n');
    } catch (_) {
      return '';
    }
  };

  // Gestion du changement de date (début ou fin)
  const handleDateChange = (field, e) => {
    const newValue = e.target.value;
    setForm(prev => {
      // Si c'est la date de fin, vérifier qu'elle est après la date de début
      if (field === 'endDate' && prev.startDate && new Date(newValue) <= new Date(prev.startDate)) {
        setError('La date de fin doit être postérieure à la date de début');
        setTimeout(() => setError(''), 3000);
        return prev;
      }

      // Si c'est la date de début, vérifier qu'elle est avant la date de fin
      if (field === 'startDate' && prev.endDate && new Date(prev.endDate) <= new Date(newValue)) {
        setError('La date de début doit être antérieure à la date de fin');
        setTimeout(() => setError(''), 3000);
        return prev;
      }

      // Formatter la date pour Mautic mais ne pas encore l'ajuster au fuseau horaire
      // L'ajustement sera fait au moment de l'envoi
      const formattedDate = formatDateForMautic(newValue);

      return {
        ...prev,
        [field]: formattedDate
      };
    });
  };

  // Gestion du changement de l'état de publication
  const handlePublishToggle = (e) => {
    const isChecked = e.target.checked;
    setForm(prev => ({
      ...prev,
      isPublished: isChecked,
      startDate: isChecked ? prev.startDate : '',
      endDate: isChecked ? prev.endDate : ''
    }));
  };

  // Génération du workflow de la campagne basé sur l'objectif, les segments et l'email
  const generateCampaignWorkflow = async () => {
    if (isWhatsappTemplateMode) {
      setError("Le mode template WhatsApp n'utilise pas de génération de workflow Mautic.");
      return;
    }

    const hasEmails = form.selectedEmails.length > 0;
    const hasPush = form.selectedPushNotifications.length > 0;
    const hasSms = form.selectedSmsMessages.length > 0;

    if (form.selectedSegments.length === 0 || (!hasEmails && !hasPush && !hasSms)) {
      setError('Veuillez sélectionner au moins un segment et au moins un email, une notification push ou un message avant de générer le workflow');
      return;
    }

    // For SMS / social messages, Mautic campaign actions require an existing message ID
    if (hasSms && form.selectedSmsMessages.some(m => !m.id)) {
      setError('Veuillez créer/enregistrer les messages sélectionnés (ID requis) avant de générer le workflow.');
      return;
    }

    setLoading(true);
    setError("");

    try {
      // Utiliser les identifiants Mautic récupérés du backend au lieu du localStorage
      const mauticUrl = userCredentials.mautic_url || '';
      const mauticUsername = userCredentials.mautic_username || '';
      const mauticPassword = userCredentials.mautic_password || '';

      // Préparation des données pour la génération du workflow
      // Ajuster les dates pour le prompt en fonction du fuseau horaire
      const adjustedStartDate = form.isPublished ? adjustDateForTimezone(form.startDate, form.timezone) : '';
      const adjustedEndDate = form.isPublished ? adjustDateForTimezone(form.endDate, form.timezone) : '';

      // Build email and push sections for the prompt
      const emailSection = hasEmails
        ? `- Emails cibles: ${form.selectedEmails.map(email => `${email.name}${email.description ? ` (${email.description})` : ''}`).join(', ')}`
        : '';

      const pushSection = hasPush
        ? `- Notifications push cibles: ${form.selectedPushNotifications.map(push => `${push.name || push.heading} (ID: ${push.id}, Message: "${(push.message || '').substring(0, 60)}")`).join(', ')}`
        : '';

      const smsSection = hasSms
        ? `- Messages (SMS / WhatsApp / Instagram / Facebook) cibles: ${form.selectedSmsMessages.map(m => `${m.name} (ID: ${m.id}, Canal: ${m.channelType || m.category?.title || m.category?.name || m.category || 'sms'}, Message: "${(m.message || m.text || '').substring(0, 60)}")`).join(', ')}`
        : '';

      const prompt = `Génère un workflow de campagne marketing avec les paramètres suivants :
        - Objectif: ${form.objectif}
        - Segments cibles: ${form.selectedSegments.map(segment => segment.name).join(', ')} ${form.selectedSegments.map(segment => segment.description).filter(desc => desc).join(', ')}
        ${emailSection}
        ${pushSection}
        ${smsSection}
        - Période: ${form.isPublished ? `Du ${adjustedStartDate} au ${adjustedEndDate} (UTC)` : 'Pas de programmation (lancement direct)'}
        - CONTRAINTE CRUCIALE: Si la campagne est programmée, inclure explicitement dans la structure générée les champs publishUp et publishDown au format 'YYYY-MM-DD HH:MM:SS' en UTC. Si elle n'est pas programmée, ne pas définir publishUp/publishDown et considérer un lancement direct.
        ${hasPush ? `- CONTRAINTE PUSH: Pour chaque notification push, utiliser le type "notification.send_notification" avec le channel "notification" et l'ID de la notification dans properties.notification (en string). Le channelId doit correspondre à l'ID de la notification push (en entier).` : ''}
        ${hasSms ? `- CONTRAINTE MESSAGES: Pour chaque message, utiliser le type "sms.send_text_sms" avec le channel "sms". Le channelId doit correspondre à l'ID du message (en entier). Dans properties, le champ "sms" DOIT contenir l'ID du message en string.` : ''}
        
        Description du workflow souhaité :
        ${form.workflowDescription || (hasEmails ? 'Le workflow doit inclure des étapes logiques comme des conditions d\'ouverture d\'email, des délais d\'attente, et des actions basées sur le comportement des utilisateurs.' : 'Le workflow doit inclure l\'envoi des notifications push sélectionnées aux segments cibles.')}`;

      // Préparer les données de timing pour l'API avec ajustement du fuseau horaire
      const timingData = form.isPublished ? {
        startDate: adjustDateForTimezone(form.startDate, form.timezone),
        endDate: adjustDateForTimezone(form.endDate, form.timezone),
        timezone: 'UTC'
      } : null;



      // Appel à l'API pour générer le workflow
      const response = await api.post('/campaigns/generate-from-prompt', {
        prompt: prompt,
        timing: timingData,
        segments: form.selectedSegments.map(s => s.mautic_segment_id),
        emails: form.selectedEmails.map(e => e.mautic_email_id),
        push_notifications: form.selectedPushNotifications.map(p => p.id),
        sms_messages: form.selectedSmsMessages.map(m => m.id),
        mautic_url: mauticUrl,
        mautic_username: mauticUsername,
        mautic_password: mauticPassword
      });



      if (response.data.success) {
        // Extraire le workflow et le JSON de la campagne de la réponse
        const campaignJson = response.data.campaign_json;

        // Extraire une description du workflow à partir de la structure de la campagne
        let workflowDescription = "";

        // Construire une description narrative plus détaillée à partir de campaign_json
        workflowDescription = buildWorkflowNarrative(campaignJson);

        // Injecter timing s'il manque dans le JSON généré
        if (form.isPublished && campaignJson && campaignJson.campaign) {
          const startAdj = adjustDateForTimezone(form.startDate, form.timezone);
          const endAdj = adjustDateForTimezone(form.endDate, form.timezone);
          if (!campaignJson.campaign.publishUp && startAdj) campaignJson.campaign.publishUp = startAdj;
          if (!campaignJson.campaign.publishDown && endAdj) campaignJson.campaign.publishDown = endAdj;
        }

        // Mise à jour du workflow généré
        setForm(prev => ({
          ...prev,
          workflow:
            workflowDescription ||
            buildWorkflowNarrative(response.data.campaign_structure) ||
            response.data.campaign_structure?.description ||
            (campaignJson?.description || ''),
          // Ne pas écraser le graphique visuel s'il existe déjà
          campaignJson: prev.visualGraph || campaignJson
        }));

        // Génération d'un nom pour la campagne si non défini
        if (!customCampaignName && campaignJson?.campaign?.name) {
          setCustomCampaignName(campaignJson.campaign.name);
        } else if (!customCampaignName) {
          const firstContent = hasEmails
            ? form.selectedEmails[0].name
            : (hasPush
              ? (form.selectedPushNotifications[0].name || form.selectedPushNotifications[0].heading)
              : (hasSms ? (form.selectedSmsMessages[0].name || 'Message') : ''));
          setCustomCampaignName(`Campagne ${form.selectedSegments[0].name} - ${firstContent}`);
        }

        setSuccess("Workflow généré avec succès!");
      } else {
        setError(response.data.message || "Erreur lors de la génération du workflow");
      }
    } catch (error) {
      console.error("Erreur lors de la génération du workflow:", error);
      setError("Erreur lors de la génération du workflow. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour créer un segment dans Unomi et Mautic
  const createSelectedSegment = async (segmentToCreate) => {
    // Si aucun segment n'est fourni, afficher une erreur
    if (!segmentToCreate) {
      setError('Aucun segment à créer');
      return;
    }

    // Ajouter l'ID du segment en cours de création à la liste des segments en chargement
    setLoadingSegmentIds(prev => [...prev, segmentToCreate.name]);
    setError('');

    try {
      // Créer une copie profonde de la configuration Unomi pour ne pas modifier l'original
      const modifiedUnomiConfig = JSON.parse(JSON.stringify(segmentToCreate.unomi_config || {}));

      // Ajouter la condition obligatoire pour properties.brand = [brand de l'utilisateur]
      const batiraCondition = {
        "type": "profilePropertyCondition",
        "parameterValues": {
          "propertyName": "properties.brand",
          "comparisonOperator": "equals",
          "propertyValue": userCredentials.brand || "batira" // Use the user's brand or fallback to "batira"
        }
      };

      // Insérer la condition batira au début du tableau de conditions
      if (modifiedUnomiConfig.condition && modifiedUnomiConfig.condition.type === 'booleanCondition') {
        if (!modifiedUnomiConfig.condition.parameterValues) {
          modifiedUnomiConfig.condition.parameterValues = { operator: 'and', subConditions: [] };
        }

        if (!modifiedUnomiConfig.condition.parameterValues.subConditions) {
          modifiedUnomiConfig.condition.parameterValues.subConditions = [];
        }

        // Ajouter la condition batira comme première condition dans le tableau subConditions
        modifiedUnomiConfig.condition.parameterValues.subConditions.unshift(batiraCondition);
      } else {
        // S'il n'y a pas de condition existante ou si ce n'est pas une condition booléenne, en créer une nouvelle
        const existingCondition = modifiedUnomiConfig.condition ? { ...modifiedUnomiConfig.condition } : null;

        modifiedUnomiConfig.condition = {
          type: 'booleanCondition',
          parameterValues: {
            operator: 'and',
            subConditions: [batiraCondition]
          }
        };

        // Ajouter la condition existante s'il y en avait une
        if (existingCondition) {
          modifiedUnomiConfig.condition.parameterValues.subConditions.push(existingCondition);
        }
      }

      // Créer le segment Unomi avec la configuration modifiée qui inclut la condition batira
      const unomiResponse = await api.post(
        '/segments/create',
        {
          segment_type: 'unomi',
          segment_config: modifiedUnomiConfig
        }
      );

      let creationMessages = [];
      let unomiSegmentId = null;
      let mauticSegmentId = null;

      if (unomiResponse.data.success) {
        creationMessages.push('Segment créé avec succès');
        // Stocker l'ID du segment Unomi si disponible
        unomiSegmentId = unomiResponse.data.segment_id || modifiedUnomiConfig.metadata?.id;

        // Mettre à jour le segment avec l'ID Unomi
        const updatedSegment = { ...segmentToCreate };
        if (unomiSegmentId && updatedSegment.unomi_config && updatedSegment.unomi_config.metadata) {
          updatedSegment.unomi_config.metadata.id = unomiSegmentId;
        }

        // Créer le segment dans Mautic si disponible
        try {
          // Utiliser les identifiants Mautic récupérés du backend au lieu du localStorage
          const mauticUrl = userCredentials.mautic_url || '';
          const mauticUsername = userCredentials.mautic_username || '';
          const mauticPassword = userCredentials.mautic_password || '';

          // Préparer la configuration Mautic
          const mauticConfig = { ...(segmentToCreate.mautic_config || {}) };

          // Ajouter les identifiants Mautic à la configuration
          mauticConfig.mautic_url = mauticUrl;
          mauticConfig.mautic_username = mauticUsername;
          mauticConfig.mautic_password = mauticPassword;

          // Utiliser l'ID du segment Unomi pour le nom du tag si disponible
          if (!mauticConfig.tag_name && unomiSegmentId) {
            mauticConfig.tag_name = unomiSegmentId;
          } else if (!mauticConfig.tag_name) {
            mauticConfig.tag_name = mauticConfig.name;
          }

          // Créer le segment dans Mautic
          const mauticResponse = await api.post(
            '/segments/create',
            {
              segment_type: 'mautic',
              segment_config: mauticConfig
            }
          );

          if (mauticResponse.data.success) {
            // Extraire les informations du tag si disponibles
            const tagInfo = mauticResponse.data.tag ?
              ` avec le tag '${mauticResponse.data.tag.tag}' (ID: ${mauticResponse.data.tag.id})` : '';
            creationMessages.push(`Segment créé avec succès${tagInfo}`);

            // Stocker l'ID du segment Mautic si disponible
            mauticSegmentId = mauticResponse.data.segment_id;

            // Mettre à jour le segment avec les IDs
            updatedSegment.unomi_segment_id = unomiSegmentId;
            updatedSegment.mautic_segment_id = mauticSegmentId;
            updatedSegment.isExisting = true; // Marquer comme existant maintenant
            if (mauticResponse.data.tag) {
              updatedSegment.mautic_tag_id = mauticResponse.data.tag.id;
            }
          } else {
            creationMessages.push(`Échec de la création du segment dans Mautic: ${mauticResponse.data.message || 'Erreur inconnue'}`);
          }
        } catch (mauticErr) {
          creationMessages.push(`Erreur lors de la création du segment dans Mautic: ${mauticErr.message}`);
        }

        // Mettre à jour le formulaire avec les segments mis à jour
        setForm(prev => {
          // Trouver l'index du segment dans le tableau des segments sélectionnés
          const segmentIndex = prev.selectedSegments.findIndex(s => s.name === updatedSegment.name);

          // Créer une copie du tableau des segments sélectionnés
          const updatedSegments = [...prev.selectedSegments];

          if (segmentIndex !== -1) {
            // Remplacer le segment existant par la version mise à jour
            updatedSegments[segmentIndex] = updatedSegment;
          } else {
            // Ajouter le segment s'il n'existe pas déjà
            updatedSegments.push(updatedSegment);
          }

          return {
            ...prev,
            selectedSegments: updatedSegments
          };
        });

        // Définir le message de succès global
        setSuccess(creationMessages.join('. '));
      } else {
        setError(unomiResponse.data.message || 'Échec de la création du segment');
      }
    } catch (err) {
      setError(err.response?.data?.detail || err.message || 'Échec de la création du segment');
    } finally {
      // Supprimer le segment de la liste des segments en chargement
      setLoadingSegmentIds(prev => prev.filter(id => id !== segmentToCreate.name));
    }
  };

  // Fonction pour suggérer des emails basés sur l'objectif et le segment
  const suggestEmails = async () => {
    // Vérifier si l'objectif est défini
    if (!form.objectif.trim()) {
      setError('Veuillez définir un objectif avant de générer des emails');
      return;
    }

    // Vérifier si des segments sont sélectionnés ou si une cible est définie
    if (form.selectedSegments.length === 0 && !form.cible.trim()) {
      setError('Veuillez sélectionner au moins un segment ou définir une cible avant de générer des emails');
      return;
    }



    setIsLoadingEmails(true);
    setError('');
    setEmailSuggestions([]);
    try { console.debug('[EMAIL_SUGGEST][UI] Start', { objectif: form.objectif, selectedSegments: form.selectedSegments.map(s => s.name), cible: form.cible }); } catch (_) { }

    try {
      // Formaté la requête pour que l'IA comprenne mieux
      const targetDescription = form.selectedSegments.length > 0
        ? form.selectedSegments.map(segment => `${segment.name}${segment.description ? ` (${segment.description})` : ''}`).join(', ')
        : form.cible;

      const formattedQuery = `Prompt Système - Assistant de Planification de Campagne Marketing
Tu es un expert en marketing automation et en création de workflows d'emails. Ta mission est de générer une séquence complète d'emails pour un workflow de campagne marketing structuré et logique.
Contexte
Objectif de campagne : ${form.objectif}
Segment(s) cible(s) : ${targetDescription}
RÈGLE FONDAMENTALE - HIÉRARCHIE STRICTE
PRIORITÉ ABSOLUE : La séquence d'emails doit être d'abord et avant tout conçue pour atteindre l'objectif de campagne de manière logique et progressive.
PRIORITÉ SECONDAIRE : Adapter le ton/style aux segments, SANS jamais compromettre la logique séquentielle de l'objectif.
Principe de cohérence séquentielle
UN SEUL PARCOURS LOGIQUE : Crée une séquence unique qui progresse vers l'objectif
SEGMENTS = ADAPTATION DE FORME : Les segments influencent uniquement le ton, vocabulaire et exemples utilisés
JAMAIS DE FRAGMENTATION : Ne crée pas d'emails différents par segment, mais des emails universels adaptés
Instructions de génération
1. Détermination du type de campagne
Évalue d'abord l'objectif pour déterminer le type de campagne optimal :
Campagne simple : Un seul email suffit (ex: promotion flash, annonce ponctuelle, newsletter)
Campagne workflow : Séquence d'emails nécessaire (ex: nurturing, onboarding, conversion complexe)
2. Structure selon le type
A. Pour une campagne simple
Génère un seul email optimisé qui :
Atteint directement l'objectif en une seule interaction
Maximise l'impact avec un message concentré
Inclut tous les éléments de persuasion nécessaires
B. Pour une campagne workflow
Génère une séquence d'emails qui forme un parcours client cohérent pour atteindre l'objectif défini. Cette séquence doit suivre une progression logique de l'engagement initial jusqu'à la conversion finale.
3. Approche créative selon la stratégie
Pour campagne simple :
Crée un email tout-en-un optimisé qui intègre tous les éléments persuasifs nécessaires pour atteindre l'objectif en une seule interaction.
Pour campagne workflow :
MÉTHODOLOGIE OBLIGATOIRE :
ÉTAPE 1 - Design de la séquence logique (ignorer les segments temporairement)
Identifie les 3-5 étapes nécessaires pour progresser de l'état actuel vers l'objectif
Crée une progression psychologique cohérente (sensibilisation → intérêt → désir → action)
Définis le rôle précis de chaque email dans cette progression
ÉTAPE 2 - Création des emails avec adaptation unifiée Chaque email doit :
Servir son rôle dans la progression vers l'objectif
Utiliser un ton/vocabulaire qui résonne avec TOUS les segments mentionnés
Inclure des exemples/références qui parlent à l'ensemble des segments
Maintenir la cohérence narrative avec l'email précédent
A. Séquence principale - Progression logique vers l'objectif : [Types d'emails déterminés par la logique de l'objectif, pas par les segments]
B. Emails de récupération - Pour gérer les non-engagés : [Emails de récupération alignés sur la même logique séquentielle]
4. Règles de génération - ORDRE STRICT
ÉTAPE 1 - Conception séquentielle : Définis d'abord la logique de progression vers l'objectif, INDÉPENDAMMENT des segments
ÉTAPE 2 - Adaptation stylistique : Ensuite seulement, adapte le ton et les exemples aux segments cibles
INTERDICTION ABSOLUE : Ne jamais créer des variantes d'emails par segment
COHÉRENCE TEMPORELLE : Chaque email doit s'appuyer sur le précédent pour construire vers l'objectif
TEST DE COHÉRENCE : La séquence doit fonctionner parfaitement même si on ignore les segments
5. Format de sortie requis
Pour campagne simple :
CAMPAGNE SIMPLE
Type : Envoi unique
Justification : [Pourquoi un seul email suffit]
 
EMAIL UNIQUE
Objet : [Ligne d'objet accrocheuse]
Contenu : [Corps de l'email complet et engageant]
CTA : [Appel à l'action clair et spécifique]
Pour campagne workflow :
CAMPAGNE WORKFLOW
Type : Séquence multi-emails
Justification : [Pourquoi plusieurs emails sont nécessaires]
Logique de progression : [Expliquer la progression psychologique vers l'objectif]
Adaptation segments : [Comment le ton/style est unifié pour tous les segments]
 
=== SÉQUENCE PRINCIPALE ===
EMAIL [N] - [TYPE BASÉ SUR LA PROGRESSION VERS L'OBJECTIF]
Rôle dans la progression : [Position dans la logique vers l'objectif]
Timing : [X jours après l'email précédent]
Objet : [Ligne d'objet accrocheuse, ton adapté aux segments]
Contenu : [Corps unifié qui progresse vers l'objectif, exemples multi-segments]
CTA : [Action cohérente avec la progression]
Lien avec email précédent : [Comment cet email s'appuie sur le précédent]
 
=== EMAILS DE RÉCUPÉRATION ===
EMAIL [N] - [TYPE DE RÉCUPÉRATION COHÉRENT AVEC LA SÉQUENCE]
Condition : [Déclencheur basé sur le non-engagement]
Timing : [Délai après la non-ouverture/non-clic]
Rôle : [Position dans la logique de récupération vers l'objectif]
Objet : [Approche différente mais cohérente avec l'objectif]
Contenu : [Récupération alignée sur la progression générale]
CTA : [Action adaptée au niveau de récupération]
6. Contraintes STRICTES
RÈGLE D'OR : Objectif d'abord, segments ensuite - JAMAIS l'inverse
INTERDICTION : Créer des emails différents par segment
OBLIGATION : Justifier la progression logique vers l'objectif
CAMPAGNE SIMPLE : 1 email unifié pour tous les segments
CAMPAGNE WORKFLOW :
Séquence principale : 3 à 5 emails dans une logique de progression claire
Emails de récupération : 2 à 3 emails cohérents avec la séquence principale
Total : Maximum 8 emails
TEST DE VALIDATION : La séquence doit raconter une histoire cohérente vers l'objectif
COHÉRENCE NARRATIVE : Chaque email doit référencer ou s'appuyer sur le précédent
ADAPTATION UNIFIÉE : Un seul ton/style qui fonctionne pour tous les segments
IMPÉRATIF : Commence par concevoir la progression logique vers l'objectif, puis unifie l'adaptation aux segments. Ne fragmente JAMAIS la séquence par segment.`;

      // Fetch LLM configuration from backend
      const llmConfig = await fetchLLMConfig();

      // Appel à l'API pour générer des suggestions d'emails
      let response;
      try {
        console.debug('[EMAIL_SUGGEST][REQ] POST /emails/suggest payload.sent');
        response = await api.post(
          '/emails/suggest',
          {
            query: formattedQuery,
            provider: llmConfig.provider,
            model: llmConfig.model
          }
        );
        console.debug('[EMAIL_SUGGEST][RES] status', { status: response?.status, success: response?.data?.success, count: response?.data?.suggestions?.length });
      } catch (networkErr) {
        console.error('[EMAIL_SUGGEST][ERR][NETWORK]', networkErr);
        throw networkErr;
      }

      if (response.data.success && response.data.suggestions && response.data.suggestions.length > 0) {
        setEmailSuggestions(response.data.suggestions);
        setSuccess('Emails suggérés générés avec succès');
      } else {
        // Message d'erreur plus spécifique avec des conseils
        setError(response.data.message || 'Aucune suggestion d\'email trouvée. Essayez de décrire votre objectif et votre cible de manière plus détaillée.');
      }
    } catch (err) {
      console.error('[EMAIL_SUGGEST][ERR]', err);
      setError(err.message || 'Échec de la génération des suggestions d\'emails. Veuillez réessayer avec un objectif et une cible plus détaillés.');
    } finally {
      try { console.debug('[EMAIL_SUGGEST][UI] End'); } catch (_) { }
      setIsLoadingEmails(false);
    }
  };

  // Fonction pour créer un email spécifique
  const createSelectedEmail = async (emailToCreate) => {
    if (!emailToCreate) {
      setError('Email non spécifié');
      return;
    }

    // Ajouter l'email à la liste des emails en cours de création
    setForm(prev => ({
      ...prev,
      loadingEmailIds: [...prev.loadingEmailIds, emailToCreate.name]
    }));

    setError('');

    try {
      // Utiliser les identifiants Mautic récupérés du backend au lieu du localStorage
      const mauticUrl = userCredentials.mautic_url || '';
      const mauticUsername = userCredentials.mautic_username || '';
      const mauticPassword = userCredentials.mautic_password || '';

      // Ajouter les identifiants Mautic à la configuration de l'email
      const emailConfig = { ...emailToCreate.config };
      emailConfig.mautic_url = mauticUrl;
      emailConfig.mautic_username = mauticUsername;
      emailConfig.mautic_password = mauticPassword;

      const response = await api.post(
        '/emails/create',
        emailConfig
      );

      if (response.data.success) {
        const emailId = response.data.email_id;
        const emailName = response.data.email_name || emailToCreate.name;

        // Mettre à jour l'email avec l'ID Mautic
        const updatedEmail = { ...emailToCreate };
        updatedEmail.mautic_email_id = emailId;
        updatedEmail.isExisting = true;

        if (response.data.email_config) {
          updatedEmail.mautic_config = response.data.email_config;
        }

        // Mettre à jour la liste des emails sélectionnés
        setForm(prev => {
          const emailIndex = prev.selectedEmails.findIndex(e => e.name === emailToCreate.name);
          const updatedEmails = [...prev.selectedEmails];

          if (emailIndex !== -1) {
            updatedEmails[emailIndex] = updatedEmail;
          }

          return {
            ...prev,
            selectedEmails: updatedEmails,
            loadingEmailIds: prev.loadingEmailIds.filter(id => id !== emailToCreate.name)
          };
        });

        setSuccess(`Email '${emailToCreate.name}' créé avec succès.`);

        // Sélectionner automatiquement l'email nouvellement créé
        handleSelectEmail(updatedEmail);

        // Ouvrir directement l'édition
        const baseConfig = updatedEmail.mautic_config || updatedEmail.config || {};
        const editorEmail = {
          ...baseConfig,
          id: baseConfig.id || baseConfig.email_id || updatedEmail.mautic_email_id,
          name: baseConfig.name || updatedEmail.name,
        };
        setEmailToEdit(editorEmail);
        setEmailEditorOpen(true);

        // Charger l'état avancé de l'éditeur pour cet email (MJML, builder, etc.)
        try {
          if (editorEmail.id) {
            loadEmailEditorState(editorEmail.id);
          }
        } catch (_) {}

        // Optionnel : si vous voulez rafraîchir la liste des emails existants
        fetchExistingEmails();
      } else {
        setError(response.data.message || 'Échec de la création de l\'email');
        // Clear loading state on non-success responses as well
        setForm(prev => ({
          ...prev,
          loadingEmailIds: prev.loadingEmailIds.filter(id => id !== emailToCreate.name)
        }));
      }
    } catch (err) {
      console.error('Erreur lors de la création de l\'email:', err);
      setError(err.response?.data?.detail || err.message || 'Échec de la création de l\'email');

      // Retirer l'email de la liste des emails en cours de création en cas d'erreur
      setForm(prev => ({
        ...prev,
        loadingEmailIds: prev.loadingEmailIds.filter(id => id !== emailToCreate.name)
      }));
    }
  };

  const handleChange = (field) => (e) => {
    // Special handling for objectif field to reset other form data when it changes
    if (field === "objectif") {
      const newObjectif = e.target.value;
      // Reset other form fields if the objective has changed
      if (newObjectif !== form.objectif) {
        setForm({
          ...form,
          objectif: newObjectif,
          // Reset other fields
          canal: "mautic_email", // Reset canal to default
          selectedContentTypes: ["email"], // Reset selected content types to default
          cible: "",
          selectedSegments: [],
          contenu: "",
          selectedEmails: [],
          loadingEmailIds: [],
          timing: "",
          workflow: "",
          resume: "",
          useExistingSegment: false,
          useExistingEmail: false,
          startDate: '',
          endDate: '',
          isPublished: false,
          timezone: '+01:00',
          workflowDescription: '',
          campaignJson: null,
          visualGraph: null,
          selectedPushNotifications: [],
          loadingPushIds: [],
          selectedSmsMessages: [],
          loadingSmsIds: [],
          useWhatsappTemplates: false,
          selectedWhatsappTemplateName: '',
          selectedWhatsappTemplateSegment: ''
        });

        // Reset any suggestions
        setSegmentSuggestions([]);
        setEmailSuggestions([]);

        // If changing the objective after having moved past step 1, show a message
        if (activeStep > 0) {
          setActiveStep(0); // Return to step 1
          setSuccess("Objectif modifié. Les données des autres étapes ont été réinitialisées.");
        }
      } else {
        // If objective text is the same, just update normally
        setForm({ ...form, [field]: e.target.value });
      }
    } else {
      // For other fields, update normally
      setForm({ ...form, [field]: e.target.value });
    }
  };

  const handleContentTypeToggle = (type, checked) => {
    setForm((prev) => {
      let nextTypes = checked
        ? Array.from(new Set([...(prev.selectedContentTypes || []), type]))
        : (prev.selectedContentTypes || []).filter((x) => x !== type);

      // Si le mode templates WhatsApp est actif, WhatsApp reste exclusif.
      if (prev.useWhatsappTemplates) {
        if (type === 'whatsapp') {
          nextTypes = checked ? ['whatsapp'] : [];
        } else if (checked) {
          nextTypes = ['whatsapp'];
        }
      }

      return {
        ...prev,
        selectedContentTypes: nextTypes,
      };
    });
  };

  const handleWhatsappTemplateModeToggle = (checked) => {
    setForm((prev) => ({
      ...prev,
      useWhatsappTemplates: checked,
      selectedContentTypes: checked ? ['whatsapp'] : prev.selectedContentTypes,
      selectedEmails: checked ? [] : prev.selectedEmails,
      selectedPushNotifications: checked ? [] : prev.selectedPushNotifications,
      selectedSmsMessages: checked ? [] : prev.selectedSmsMessages,
      selectedWhatsappTemplateName: checked ? prev.selectedWhatsappTemplateName : '',
      selectedWhatsappTemplateSegment: checked
        ? (prev.selectedWhatsappTemplateSegment
          || String(prev.selectedSegments?.[0]?.mautic_segment_id || prev.selectedSegments?.[0]?.id || prev.selectedSegments?.[0]?.name || ''))
        : '',
      workflow: checked ? prev.workflow : '',
      campaignJson: checked ? prev.campaignJson : null,
      visualGraph: checked ? null : prev.visualGraph,
    }));
  };

  // Render content for each step
  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <Box>
            <Typography sx={customStyles.stepTitle}>
              Définir l'objectif et le canal principal
            </Typography>
            {suggestions && showSuggestions && (
              <Collapse in={showSuggestions}>
                <Alert
                  severity="info"
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => setShowSuggestions(false)}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                  sx={{ mb: 2 }}
                >
                  <Typography variant="body2">
                    Suggestions IA pour la campagne "{campaignName}" :
                  </Typography>
                  <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
                    {suggestions.map((s, i) => (
                      <li key={i}>
                        <Typography variant="body2" color="text.secondary">
                          {s}
                        </Typography>
                      </li>
                    ))}
                  </ul>
                </Alert>
              </Collapse>
            )}

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" color="#868e96" mb={1} fontFamily="Montserrat, Arial, sans-serif">
                  Objectif de la campagne
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  maxRows={4}
                  placeholder="Ex: Augmenter les ventes de produit X..."
                  value={form.objectif}
                  onChange={handleChange("objectif")}
                  sx={{
                    bgcolor: '#f8f9fa',
                    borderRadius: 2,
                    fontFamily: 'Montserrat, Arial, sans-serif',
                    fontSize: 15
                  }}
                  InputProps={{
                    style: { fontFamily: 'Montserrat, Arial, sans-serif' }
                  }}
                />
              </Grid>

            </Grid>

            <Box sx={{ mt: 3 }}>
              <Typography variant="body2" color="#868e96" fontFamily="Montserrat, Arial, sans-serif">
                Définissez clairement l'objectif de votre campagne pour que l'IA puisse vous suggérer des segments pertinents à l'étape suivante.
              </Typography>
            </Box>
          </Box>
        );
      case 1:
        return (
          <Box>
            <Typography sx={customStyles.stepTitle}>
              Quelle est la cible de la campagne ?
            </Typography>

            <Box sx={{ mb: 6 }}>
              <Typography variant="body2" color="#868e96" mb={2} fontFamily="Montserrat, Arial, sans-serif">
                Sélectionner un segment existant
              </Typography>

              <FormControl fullWidth sx={{ mb: 2 }}>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={filteredSegments}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  value={form.selectedSegments.filter(s => s.isExisting).map(s => ({ id: s.mautic_segment_id, name: s.name, description: s.description }))}
                  onChange={(_, newValue) => {
                    const selectedSegments = newValue.map(segment => ({
                      name: segment.name,
                      description: segment.description || '',
                      mautic_segment_id: segment.id,
                      isExisting: true
                    }));
                    setForm(prev => ({
                      ...prev,
                      selectedSegments: [
                        ...prev.selectedSegments.filter(s => !s.isExisting),
                        ...selectedSegments
                      ]
                    }));
                  }}
                  inputValue={segmentSearchText}
                  onInputChange={(_, newInputValue, reason) => {
                    if (reason !== 'input') return;
                    const searchValue = newInputValue || '';
                    setSegmentSearchText(searchValue);
                    if (!searchValue.trim()) {
                      setFilteredSegments(existingSegments);
                    } else {
                      const filtered = existingSegments.filter(segment =>
                        segment.name.toLowerCase().includes(searchValue.toLowerCase()) ||
                        (segment.description && segment.description.toLowerCase().includes(searchValue.toLowerCase()))
                      );
                      setFilteredSegments(filtered);
                    }
                  }}
                  clearOnBlur={false}
                  loading={isLoadingExistingSegments}
                  renderTags={() => null}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Rechercher un segment..."
                      size="small"
                      autoComplete="off"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon sx={{ fontSize: '1rem' }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="body2" sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 500 }}>
                          {option.name}
                        </Typography>
                        {option.description && (
                          <Typography variant="caption" sx={{ color: '#6b7280', fontFamily: 'Montserrat, Arial, sans-serif' }}>
                            {option.description}
                          </Typography>
                        )}
                      </Box>
                    </li>
                  )}
                  sx={{
                    bgcolor: '#f8f9fa',
                    borderRadius: 2,
                    fontFamily: 'Montserrat, Arial, sans-serif',
                    fontSize: 15
                  }}
                />
                {isLoadingExistingSegments && (
                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                    <CircularProgress size={16} sx={{ mr: 1 }} />
                    <FormHelperText>Chargement des segments...</FormHelperText>
                  </Box>
                )}
                {!isLoadingExistingSegments && existingSegments.length === 0 && (
                  <FormHelperText error>Aucun segment disponible</FormHelperText>
                )}
                {/* Tags sous le champ pour les segments sélectionnés */}
                {form.selectedSegments.length > 0 && (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                    {form.selectedSegments.map((segment, index) => (
                      <Chip
                        key={`${segment.name}-${index}`}
                        label={segment.name}
                        onDelete={() => handleSelectSegment(segment)}
                        size="small"
                        sx={{
                          fontFamily: 'Montserrat, Arial, sans-serif',
                          fontSize: '0.75rem',
                          height: '24px'
                        }}
                      />
                    ))}
                  </Box>
                )}
              </FormControl>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography variant="body2" color="#868e96" mb={2} fontFamily="Montserrat, Arial, sans-serif">
                Ou demandez à l'IA
              </Typography>

              <Button
                onClick={suggestSegments}
                disabled={isLoadingSegments || !form.objectif.trim()}
                startIcon={isLoadingSegments ? <CircularProgress size={20} /> : <AutoAwesomeIcon />}
                sx={{
                  ...customStyles.btn,
                  ...customStyles.btnSuggest,
                  fontFamily: 'Montserrat, Arial, sans-serif'
                }}
              >
                Suggérer un segment
              </Button>

              {!form.objectif.trim() && (
                <Typography variant="body2" color="error" sx={{ mt: 1, fontFamily: 'Montserrat, Arial, sans-serif' }}>
                  Veuillez d'abord définir un objectif pour générer des segments.
                </Typography>
              )}
            </Box>

            {segmentSuggestions.length > 0 && (
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" gutterBottom fontFamily="Montserrat, Arial, sans-serif">
                  Segments suggérés par l'IA
                </Typography>

                {segmentSuggestions.map((segment, index) => (
                  <Box
                    key={index}
                    sx={{
                      ...customStyles.card,
                      mb: 2,
                      cursor: 'pointer',
                      border: form.selectedSegments.some(s => s.name === segment.name) ? '2px solid #007B8A' : '1px solid #e2e8f0',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        borderColor: '#007B8A',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                      }
                    }}
                    onClick={() => handleSelectSegment(segment)}
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                      <Typography variant="h6" fontFamily="Montserrat, Arial, sans-serif" sx={{ color: '#1f2937' }}>
                        {segment.name}
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        {segment.isExisting ? (
                          <Chip
                            label="Segment existant"
                            color="success"
                            size="small"
                            sx={{
                              fontFamily: 'Montserrat, Arial, sans-serif',
                              fontSize: '0.75rem',
                              height: '20px'
                            }}
                          />
                        ) : (
                          <Chip
                            label="Nouveau segment"
                            color="primary"
                            size="small"
                            sx={{
                              fontFamily: 'Montserrat, Arial, sans-serif',
                              fontSize: '0.75rem',
                              height: '20px'
                            }}
                          />
                        )}
                        {form.selectedSegments.some(s => s.name === segment.name) && (
                          <Chip
                            label="Sélectionné"
                            color="info"
                            size="small"
                            sx={{
                              fontFamily: 'Montserrat, Arial, sans-serif',
                              fontSize: '0.75rem',
                              height: '20px'
                            }}
                          />
                        )}
                      </Box>
                    </Box>
                    <Typography variant="body2" color="#6b7280" paragraph fontFamily="Montserrat, Arial, sans-serif" sx={{ fontSize: '0.875rem' }}>
                      {segment.description}
                    </Typography>
                    {!segment.isExisting && (
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          createSelectedSegment(segment);
                        }}
                        disabled={loadingSegmentIds.includes(segment.name) || !mauticAvailable}
                        startIcon={loadingSegmentIds.includes(segment.name) ? <CircularProgress size={16} /> : null}
                        sx={{
                          fontFamily: 'Montserrat, Arial, sans-serif',
                          fontSize: '0.875rem',
                          padding: '0.25rem 0.75rem'
                        }}
                      >
                        Créer le segment
                      </Button>
                    )}
                  </Box>
                ))}

                {form.selectedSegments.length > 0 && (
                  <Box sx={{ mt: 3 }}>
                    <Typography variant="h6" gutterBottom fontFamily="Montserrat, Arial, sans-serif">
                      Segments sélectionnés :
                    </Typography>
                    {form.selectedSegments.map((segment, index) => (
                      <Typography key={index} variant="body1" gutterBottom fontFamily="Montserrat, Arial, sans-serif">
                        • {segment.name} {segment.isExisting ? '(Existant)' : '(Nouveau)'}
                      </Typography>
                    ))}

                    {form.selectedSegments.map((segment, idx) => (
                      <Accordion key={idx} sx={{ mb: 2 }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography fontFamily="Montserrat, Arial, sans-serif">Configuration du segment: {segment.name}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <pre style={{ overflow: 'auto', maxHeight: '300px', fontFamily: 'monospace' }}>
                            {JSON.stringify(segment.unomi_config || {}, null, 2)}
                          </pre>
                        </AccordionDetails>
                      </Accordion>
                    ))}

                    {/* Le bouton global pour créer le segment a été supprimé car nous avons maintenant des boutons individuels pour chaque nouveau segment */}

                    {!mauticAvailable && (
                      <Alert severity="warning" sx={{ mt: 2 }}>
                        L'intégration Mautic n'est pas disponible car les identifiants ne sont pas configurés.
                      </Alert>
                    )}
                  </Box>
                )}
              </Box>
            )}
          </Box>
        );
      case 2:
        return (
          <Box>
            <Typography sx={customStyles.stepTitle}>
              Préparer le Contenu de la Campagne
            </Typography>

            {/* Step 1: Select Content Type */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="body2" color="#868e96" mb={2} fontFamily="Montserrat, Arial, sans-serif">
                Type de contenu
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2, borderBottom: '1px solid #e2e8f0', pb: 2, mb: 2 }}>
                {/* Email */}
                <FormControlLabel
                  control={<Checkbox checked={form.selectedContentTypes.includes('email')} onChange={(e) => handleContentTypeToggle('email', e.target.checked)} disabled={isWhatsappTemplateMode} sx={{ color: '#10B981', '&.Mui-checked': { color: '#10B981' } }} />}
                  label={<Typography sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 500, color: '#1f2937' }}>📧 Email</Typography>}
                />
                {/* Push */}
                <FormControlLabel
                  control={<Checkbox checked={form.selectedContentTypes.includes('push')} onChange={(e) => handleContentTypeToggle('push', e.target.checked)} disabled={isWhatsappTemplateMode} sx={{ color: '#8B5CF6', '&.Mui-checked': { color: '#8B5CF6' } }} />}
                  label={<Typography sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 500, color: '#1f2937' }}>🔔 Notification Push</Typography>}
                />
                {/* Facebook */}
                <FormControlLabel
                  control={<Checkbox checked={form.selectedContentTypes.includes('facebook')} onChange={(e) => handleContentTypeToggle('facebook', e.target.checked)} disabled={isWhatsappTemplateMode} sx={{ color: '#1877F2', '&.Mui-checked': { color: '#1877F2' } }} />}
                  label={<Typography sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 500, color: '#1f2937' }}>💬 Facebook</Typography>}
                />
                {/* WhatsApp */}
                <FormControlLabel
                  control={<Checkbox checked={form.selectedContentTypes.includes('whatsapp')} onChange={(e) => handleContentTypeToggle('whatsapp', e.target.checked)} sx={{ color: '#25D366', '&.Mui-checked': { color: '#25D366' } }} />}
                  label={<Typography sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 500, color: '#1f2937' }}>📱 WhatsApp</Typography>}
                />
                {/* Instagram */}
                <FormControlLabel
                  control={<Checkbox checked={form.selectedContentTypes.includes('instagram')} onChange={(e) => handleContentTypeToggle('instagram', e.target.checked)} disabled={isWhatsappTemplateMode} sx={{ color: '#E1306C', '&.Mui-checked': { color: '#E1306C' } }} />}
                  label={<Typography sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 500, color: '#1f2937' }}>📸 Instagram</Typography>}
                />
                {/* SMS */}
                <FormControlLabel
                  control={<Checkbox checked={form.selectedContentTypes.includes('sms')} onChange={(e) => handleContentTypeToggle('sms', e.target.checked)} disabled={isWhatsappTemplateMode} sx={{ color: '#F59E0B', '&.Mui-checked': { color: '#F59E0B' } }} />}
                  label={<Typography sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 500, color: '#1f2937' }}>💬 SMS</Typography>}
                />
              </Box>

              {form.selectedContentTypes.includes('whatsapp') && (
                <Box sx={{ mt: 1.5, mb: 1.5 }}>
                  <FormControlLabel
                    control={(
                      <Switch
                        checked={Boolean(form.useWhatsappTemplates)}
                        onChange={(e) => handleWhatsappTemplateModeToggle(e.target.checked)}
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-checked': { color: '#25D366' },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#25D366' },
                        }}
                      />
                    )}
                    label={(
                      <Typography sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 600, color: '#1f2937' }}>
                        Activer les templates WhatsApp (mode exclusif)
                      </Typography>
                    )}
                  />
                  {form.useWhatsappTemplates && (
                    <Typography variant="caption" sx={{ display: 'block', color: '#6b7280', fontFamily: 'Montserrat, Arial, sans-serif' }}>
                      Le mode template WhatsApp désactive Email, Push, Facebook, Instagram et SMS.
                    </Typography>
                  )}
                </Box>
              )}
            </Box>


            {/* Step 2: Select Generation Method (only if at least one content type is selected) */}
            {form.selectedContentTypes.length > 0 && !isWhatsappTemplateMode && (
              <Box sx={{ mb: 3 }}>
                <Typography variant="body2" color="#868e96" mb={2} fontFamily="Montserrat, Arial, sans-serif">
                  Mode de création
                </Typography>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                  borderBottom: '1px solid #e2e8f0',
                  pb: 2,
                  mb: 2
                }}>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={!form.useExistingEmail}
                        onChange={() => setForm(prev => ({ ...prev, useExistingEmail: false }))}
                        sx={{ color: '#10B981' }}
                      />
                    }
                    label={
                      <Typography sx={{
                        fontFamily: 'Montserrat, Arial, sans-serif',
                        fontWeight: 500,
                        color: '#1f2937'
                      }}>
                        Générer par IA
                      </Typography>
                    }
                    sx={{ cursor: 'pointer' }}
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        checked={form.useExistingEmail}
                        onChange={() => setForm(prev => ({ ...prev, useExistingEmail: true }))}
                        sx={{ color: '#10B981' }}
                      />
                    }
                    label={
                      <Typography sx={{
                        fontFamily: 'Montserrat, Arial, sans-serif',
                        fontWeight: 500,
                        color: '#1f2937'
                      }}>
                        Sélectionner des templates
                      </Typography>
                    }
                    sx={{ cursor: 'pointer' }}
                  />
                </Box>
              </Box>
            )}

            {isWhatsappTemplateMode && (
              <Box sx={{ mb: 3, p: 2, border: '1px solid #dcfce7', borderRadius: 2, bgcolor: '#f0fdf4' }}>
                <Typography variant="body2" sx={{ fontWeight: 700, color: '#166534', mb: 1, fontFamily: 'Montserrat, Arial, sans-serif' }}>
                  Campagne WhatsApp via templates
                </Typography>
                <Typography variant="body2" sx={{ color: '#166534', fontFamily: 'Montserrat, Arial, sans-serif' }}>
                  Cette campagne sera lancée depuis le module Discussions (Inbox API), sans création de campagne Mautic.
                </Typography>
              </Box>
            )}

            {isWhatsappTemplateMode && (
              <Box sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2" color="#868e96" mb={1} fontFamily="Montserrat, Arial, sans-serif">
                      Template WhatsApp
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        size="small"
                        value={form.selectedWhatsappTemplateName}
                        onChange={(e) => setForm((prev) => ({ ...prev, selectedWhatsappTemplateName: e.target.value }))}
                        displayEmpty
                        sx={{ bgcolor: '#f8f9fa', borderRadius: 2, fontFamily: 'Montserrat, Arial, sans-serif' }}
                      >
                        <MenuItem value="">Choisir un template</MenuItem>
                        {whatsappTemplates.map((tpl) => (
                          <MenuItem key={tpl?.id || tpl?.name} value={tpl?.name || ''}>
                            {tpl?.name || 'Template sans nom'}
                          </MenuItem>
                        ))}
                      </Select>
                      {loadingWhatsappTemplates ? (
                        <FormHelperText>Chargement des templates WhatsApp...</FormHelperText>
                      ) : null}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2" color="#868e96" mb={1} fontFamily="Montserrat, Arial, sans-serif">
                      Segment à cibler
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        size="small"
                        value={form.selectedWhatsappTemplateSegment}
                        onChange={(e) => setForm((prev) => ({ ...prev, selectedWhatsappTemplateSegment: e.target.value }))}
                        displayEmpty
                        sx={{ bgcolor: '#f8f9fa', borderRadius: 2, fontFamily: 'Montserrat, Arial, sans-serif' }}
                      >
                        <MenuItem value="">Choisir un segment sélectionné</MenuItem>
                        {(form.selectedSegments || []).map((seg) => {
                          const segValue = String(seg?.mautic_segment_id || seg?.id || seg?.name || '');
                          return (
                            <MenuItem key={segValue} value={segValue}>
                              {seg?.name || `Segment ${segValue}`}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            )}

            {/* AI Generation Panel - Email */}
            {!form.useExistingEmail && form.selectedContentTypes.length > 0 && !isWhatsappTemplateMode && (
              <Box>
                {/* Bouton IA Email */}
                {form.selectedContentTypes.includes('email') && (
                  <Box sx={{ mt: 4, mb: 2, borderLeft: '4px solid #10B981', pl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 700, color: '#10B981', mb: 2, fontFamily: 'Montserrat, Arial, sans-serif' }}
                    >
                      📧 Email
                    </Typography>
                    <Button
                      onClick={async () => {
                        await suggestEmails();
                      }}
                      disabled={isLoadingEmails || !form.objectif.trim() || (!form.cible.trim() && form.selectedSegments.length === 0)}
                      startIcon={isLoadingEmails ? <CircularProgress size={20} /> : <AutoAwesomeIcon />}
                      sx={{
                        ...customStyles.btn,
                        ...customStyles.btnSuggest,
                        fontFamily: 'Montserrat, Arial, sans-serif',
                        mb: 2
                      }}
                    >
                      Générer une séquence d'emails
                    </Button>

                    {(!form.objectif.trim() || (!form.cible.trim() && form.selectedSegments.length === 0)) && (
                      <Typography variant="body2" color="error" sx={{ mt: 1, fontFamily: 'Montserrat, Arial, sans-serif' }}>
                        {!form.objectif.trim()
                          ? "Veuillez d'abord définir un objectif pour générer du contenu."
                          : "Veuillez sélectionner un segment ou définir une cible pour générer du contenu."}
                      </Typography>
                    )}

                    {/* Email Results */}
                    <Box sx={{ mt: 2 }}>
                      {form.selectedContentTypes.length > 1 && emailSuggestions.length > 0 && (
                        <Typography variant="subtitle2" color="primary" gutterBottom sx={{ fontWeight: 600, fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          Séquence d'Emails suggérée
                        </Typography>
                      )}
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {emailSuggestions.map((email, index) => (
                          <Box
                            key={index}
                            sx={{
                              ...customStyles.card,
                              cursor: 'pointer',
                              border: form.selectedEmails.some(e => e.name === email.name) ? '2px solid #1976d2' : '1px solid #e2e8f0',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                borderColor: '#1976d2',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                              }
                            }}
                            onClick={() => handleSelectEmail(email)}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                              <Typography variant="h6" fontFamily="Montserrat, Arial, sans-serif" sx={{ color: '#1f2937' }}>
                                {email.name}
                              </Typography>
                              <Box sx={{ display: 'flex', gap: 1 }}>
                                {email.isExisting ? (
                                  <Chip
                                    label="Email existant"
                                    color="success"
                                    size="small"
                                    sx={{
                                      fontFamily: 'Montserrat, Arial, sans-serif',
                                      fontSize: '0.75rem',
                                      height: '20px'
                                    }}
                                  />
                                ) : (
                                  <Chip
                                    label="Nouvel email"
                                    color="primary"
                                    size="small"
                                    sx={{
                                      fontFamily: 'Montserrat, Arial, sans-serif',
                                      fontSize: '0.75rem',
                                      height: '20px'
                                    }}
                                  />
                                )}
                                {form.selectedEmails.some(e => e.name === email.name) && (
                                  <Chip
                                    label="Sélectionné"
                                    color="info"
                                    size="small"
                                    sx={{
                                      fontFamily: 'Montserrat, Arial, sans-serif',
                                      fontSize: '0.75rem',
                                      height: '20px'
                                    }}
                                  />
                                )}
                              </Box>
                            </Box>
                            <Typography variant="body2" color="#6b7280" paragraph fontFamily="Montserrat, Arial, sans-serif" sx={{ fontSize: '0.875rem' }}>
                              {email.description}
                            </Typography>
                            {/* Boutons Créer + Éditer pour emails IA */}
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', mt: 1 }} onClick={e => e.stopPropagation()}>
                              {(() => {
                                const selectedEmail = form.selectedEmails.find(e => e.name === email.name);
                                const isCreated = selectedEmail?.isExisting === true;
                                return (
                                  <>
                                    {!isCreated && (
                                      <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          createSelectedEmail(email);
                                        }}
                                        disabled={form.loadingEmailIds.includes(email.name)}
                                        startIcon={form.loadingEmailIds.includes(email.name) ? <CircularProgress size={16} /> : null}
                                        sx={{
                                          fontFamily: 'Montserrat, Arial, sans-serif',
                                          fontSize: '0.875rem',
                                          padding: '0.25rem 0.75rem'
                                        }}
                                      >
                                        Créer l'email
                                      </Button>
                                    )}
                                    <Tooltip
                                      title={!isCreated ? "Créez d'abord cet email pour pouvoir l'éditer" : "Ouvrir l'éditeur d'email"}
                                      arrow
                                    >
                                      <span>
                                        <Button
                                          variant="outlined"
                                          size="small"
                                          disabled={!isCreated}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            if (isCreated && selectedEmail) {
                                              // Construire un objet email complet pour l'éditeur,
                                              // en s'assurant qu'un champ `id` (ID Mautic) est toujours présent.
                                              const baseConfig = selectedEmail.mautic_config || selectedEmail.config || {};
                                              const editorEmail = {
                                                ...baseConfig,
                                                id: baseConfig.id || baseConfig.email_id || selectedEmail.mautic_email_id,
                                                name: baseConfig.name || selectedEmail.name,
                                              };
                                              setEmailToEdit(editorEmail);
                                              setEmailEditorOpen(true);
                                            }
                                          }}
                                          startIcon={<AutoAwesomeIcon sx={{ fontSize: '0.9rem' }} />}
                                          sx={{
                                            fontFamily: 'Montserrat, Arial, sans-serif',
                                            fontSize: '0.875rem',
                                            padding: '0.25rem 0.75rem',
                                            opacity: isCreated ? 1 : 0.5
                                          }}
                                        >
                                          Éditer
                                        </Button>
                                      </span>
                                    </Tooltip>
                                    {!isCreated && (
                                      <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontStyle: 'italic' }}>
                                        Créez cet email pour pouvoir l'éditer
                                      </Typography>
                                    )}
                                  </>
                                );
                              })()}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                )}

                {/* Push Notification Results - dans le panneau IA global */}
                {form.selectedContentTypes.includes('push') && (
                  <Box sx={{ mt: 4, mb: 2, borderLeft: '4px solid #8B5CF6', pl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 700, color: '#8B5CF6', mb: 2, fontFamily: 'Montserrat, Arial, sans-serif' }}
                    >
                      🔔 Notification Push
                    </Typography>
                    <Button
                      onClick={async () => {
                        await suggestPushNotifications();
                      }}
                      disabled={isLoadingPush || !form.objectif.trim() || (!form.cible.trim() && form.selectedSegments.length === 0)}
                      startIcon={isLoadingPush ? <CircularProgress size={20} /> : <AutoAwesomeIcon />}
                      sx={{
                        ...customStyles.btn,
                        fontFamily: 'Montserrat, Arial, sans-serif',
                        mb: 2,
                        backgroundColor: '#8B5CF6',
                        color: '#FFFFFF',
                        '&:hover': { backgroundColor: '#7C3AED' }
                      }}
                    >
                      GÉNÉRER DES NOTIFICATIONS PUSH
                    </Button>
                    {pushSuggestions.length > 0 && (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {pushSuggestions.map((push, index) => (
                          <Box
                            key={index}
                            sx={{
                              ...customStyles.card,
                              cursor: 'pointer',
                              border: form.selectedPushNotifications.some(p => p.name === push.name) ? '2px solid #9c27b0' : '1px solid #e2e8f0',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                borderColor: '#9c27b0',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                              }
                            }}
                            onClick={() => handleSelectPushNotification(push)}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                              <Typography variant="h6" fontFamily="Montserrat, Arial, sans-serif" sx={{ color: '#1f2937' }}>
                                {push.heading}
                              </Typography>
                              <Box sx={{ display: 'flex', gap: 1 }}>
                                <Chip
                                  label="Nouveau Push"
                                  color="secondary"
                                  size="small"
                                  sx={{
                                    fontFamily: 'Montserrat, Arial, sans-serif',
                                    fontSize: '0.75rem',
                                    height: '20px'
                                  }}
                                />
                                {form.selectedPushNotifications.some(p => p.name === push.name) && (
                                  <Chip
                                    label="Sélectionné"
                                    color="info"
                                    size="small"
                                    sx={{
                                      fontFamily: 'Montserrat, Arial, sans-serif',
                                      fontSize: '0.75rem',
                                      height: '20px'
                                    }}
                                  />
                                )}
                              </Box>
                            </Box>
                            <Typography variant="body2" color="text.secondary" fontFamily="Montserrat, Arial, sans-serif" sx={{ mb: 1 }}>
                              <strong>Message:</strong> {push.message}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" fontFamily="Montserrat, Arial, sans-serif">
                              Nom: {push.name}
                            </Typography>
                            {/* Boutons Créer + Éditer pour push IA */}
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', mt: 1 }} onClick={e => e.stopPropagation()}>
                              {(() => {
                                const selectedPush = form.selectedPushNotifications.find(p => p.name === push.name);
                                const isCreated = selectedPush?.isExisting === true;
                                return (
                                  <>
                                    {!isCreated && (
                                      <Button
                                        variant="outlined"
                                        color="secondary"
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          createSelectedPush(push);
                                        }}
                                        disabled={form.loadingPushIds.includes(push.name)}
                                        startIcon={form.loadingPushIds.includes(push.name) ? <CircularProgress size={16} /> : null}
                                        sx={{
                                          fontFamily: 'Montserrat, Arial, sans-serif',
                                          fontSize: '0.875rem',
                                          padding: '0.25rem 0.75rem'
                                        }}
                                      >
                                        Créer le push
                                      </Button>
                                    )}
                                    <Tooltip
                                      title={!isCreated ? "Créez d'abord cette notification pour pouvoir l'éditer" : "Modifier la notification push"}
                                      arrow
                                    >
                                      <span>
                                        <Button
                                          variant="outlined"
                                          color="secondary"
                                          size="small"
                                          disabled={!isCreated}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            if (isCreated && selectedPush) {
                                              handleEditPushInCampaign(selectedPush);
                                            }
                                          }}
                                          startIcon={<EditIcon sx={{ fontSize: '0.9rem' }} />}
                                          sx={{
                                            fontFamily: 'Montserrat, Arial, sans-serif',
                                            fontSize: '0.875rem',
                                            padding: '0.25rem 0.75rem',
                                            opacity: isCreated ? 1 : 0.5
                                          }}
                                        >
                                          Éditer
                                        </Button>
                                      </span>
                                    </Tooltip>
                                    {!isCreated && (
                                      <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontStyle: 'italic' }}>
                                        Créez cette notification pour pouvoir l'éditer
                                      </Typography>
                                    )}
                                  </>
                                );
                              })()}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            )}



            {/* Panneau Templates - Email */}
            {form.useExistingEmail && form.selectedContentTypes.includes('email') && !isWhatsappTemplateMode && (
              <Box sx={{ mt: 4, mb: 2, borderLeft: '4px solid #10B981', pl: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 700, color: '#10B981', mb: 2, fontFamily: 'Montserrat, Arial, sans-serif' }}
                >
                  📧 Email
                </Typography>
                {/* ... existing email template logic ... */}
                <Box sx={{ display: 'flex', alignItems: 'end', gap: 2, mb: 2 }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="body2" color="#868e96" mb={1} fontFamily="Montserrat, Arial, sans-serif">
                      Choisir un template Email
                    </Typography>
                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        disableCloseOnSelect
                        options={filteredEmails}
                        getOptionLabel={(option) => option.name}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        value={form.selectedEmails
                          .filter(e => e.isExisting)
                          .map(e => {
                            const full = e.config || existingEmails.find(x => String(x.id) === String(e.mautic_email_id));
                            return full || { id: e.mautic_email_id, name: e.name, description: e.description };
                          })}
                        onChange={(_, newValue) => {
                          const selectedEmails = newValue.map(email => {
                            // email ici est l'option complète; conserver l'objet entier dans config
                            return {
                              name: email.name,
                              description: email.description || '',
                              mautic_email_id: email.id,
                              isExisting: true,
                              config: email
                            };
                          });
                          setForm(prev => ({
                            ...prev,
                            selectedEmails: [
                              ...prev.selectedEmails.filter(e => !e.isExisting),
                              ...selectedEmails
                            ]
                          }));
                        }}
                        inputValue={emailSearchText}
                        onInputChange={(_, newInputValue, reason) => {
                          if (reason !== 'input') return;
                          const searchValue = newInputValue || '';
                          setEmailSearchText(searchValue);
                          if (!searchValue.trim()) {
                            setFilteredEmails(existingEmails);
                          } else {
                            const filtered = existingEmails.filter(email =>
                              email.name.toLowerCase().includes(searchValue.toLowerCase()) ||
                              (email.subject && email.subject.toLowerCase().includes(searchValue.toLowerCase()))
                            );
                            setFilteredEmails(filtered);
                          }
                        }}
                        clearOnBlur={false}
                        loading={isLoadingExistingEmails}
                        renderTags={() => null}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Rechercher un template d'email..."
                            size="small"
                            autoComplete="off"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon sx={{ fontSize: '1rem' }} />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            <ListItemText
                              primary={option.name}
                              secondary={option.dateAdded && new Date(option.dateAdded).toLocaleDateString()}
                            />
                          </li>
                        )}
                        sx={{
                          bgcolor: '#f8f9fa',
                          borderRadius: 2,
                          fontFamily: 'Montserrat, Arial, sans-serif',
                          fontSize: 15
                        }}
                      />
                      {isLoadingExistingEmails && (
                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                          <CircularProgress size={16} sx={{ mr: 1 }} />
                          <FormHelperText>Chargement des templates d'email...</FormHelperText>
                        </Box>
                      )}
                      {!isLoadingExistingEmails && filteredEmails.length === 0 && (
                        <FormHelperText error>Aucun template d'email disponible</FormHelperText>
                      )}
                      {form.selectedEmails.filter(e => e.isExisting).length > 0 && (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                          {form.selectedEmails.filter(e => e.isExisting).map((email) => (
                            <Chip
                              key={email.mautic_email_id}
                              label={email.name}
                              color="primary"
                              variant="outlined"
                              onDelete={() => {
                                setForm(prev => ({
                                  ...prev,
                                  selectedEmails: prev.selectedEmails.filter(se => !(se.isExisting && se.mautic_email_id === email.mautic_email_id))
                                }));
                              }}
                              size="small"
                              sx={{
                                fontFamily: 'Montserrat, Arial, sans-serif',
                                fontSize: '0.75rem',
                                height: '24px'
                              }}
                            />
                          ))}
                        </Box>
                      )}
                    </FormControl>
                  </Box>

                </Box>

                {/* Container pour les templates sélectionnés */}
                <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {form.selectedEmails.filter(e => e.isExisting).map((email, index) => (
                    <Box
                      key={index}
                      sx={{
                        ...customStyles.card,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 2
                      }}
                    >
                      <Box>
                        <Typography variant="h6" fontFamily="Montserrat, Arial, sans-serif" sx={{ color: '#1f2937' }}>
                          Séquence {index + 1}: {email.name}
                        </Typography>
                        <Typography variant="body2" color="#6b7280" fontFamily="Montserrat, Arial, sans-serif" sx={{ fontSize: '0.875rem' }}>
                          Ordre: {index + 1}
                        </Typography>
                      </Box>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => {
                          try {
                            const source = email.config || {};
                            const editorEmail = source.id ? source : {
                              id: email.mautic_email_id,
                              name: email.name,
                              customHtml: (email.config && email.config.customHtml) || undefined,
                              content: (email.config && email.config.content) || undefined
                            };
                            setEmailToEdit(editorEmail);
                            setEmailEditorOpen(true);

                          // Aligner avec la page Emails : charger l'état éditeur complet
                          try {
                            if (editorEmail.id) {
                              loadEmailEditorState(editorEmail.id);
                            }
                          } catch (_) {}
                          } catch (_) {
                            setEmailToEdit({ id: email.mautic_email_id, name: email.name });
                            setEmailEditorOpen(true);

                          try {
                            if (email.mautic_email_id) {
                              loadEmailEditorState(email.mautic_email_id);
                            }
                          } catch (_) {}
                          }
                        }}
                        sx={{
                          fontFamily: 'Montserrat, Arial, sans-serif',
                          fontSize: '0.875rem',
                          padding: '0.25rem 0.75rem'
                        }}
                      >
                        <AutoAwesomeIcon sx={{ fontSize: '1rem', mr: 0.5 }} />
                        Éditer
                      </Button>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}

            {/* Panneau Templates - Push Notification */}
            {form.useExistingEmail && form.selectedContentTypes.includes('push') && !isWhatsappTemplateMode && (
              <Box sx={{ mt: 4, mb: 2, borderLeft: '4px solid #8B5CF6', pl: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 700, color: '#8B5CF6', mb: 2, fontFamily: 'Montserrat, Arial, sans-serif' }}
                >
                  🔔 Notification Push
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'end', gap: 2, mb: 2 }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="body2" color="#868e96" mb={1} fontFamily="Montserrat, Arial, sans-serif">
                      Choisir une notification Push
                    </Typography>
                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        disableCloseOnSelect
                        options={filteredPushNotifications}
                        getOptionLabel={(option) => option.name || option.title || ""}
                        isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                        value={form.selectedPushNotifications
                          .filter(push => push.isExisting)
                          .map(push => existingPushNotifications.find(ex => String(ex.id) === String(push.id)) || push)
                        }
                        onChange={(_, newValue) => {
                          const newExisting = newValue.map(push => ({
                            ...push,
                            isExisting: true
                          }));

                          setForm(prev => {
                            const manuallyAdded = prev.selectedPushNotifications.filter(p => !p.isExisting);
                            return {
                              ...prev,
                              selectedPushNotifications: [...manuallyAdded, ...newExisting]
                            };
                          });
                        }}
                        inputValue={pushSearchText}
                        onInputChange={(_, newInputValue, reason) => {
                          if (reason !== 'input') return;
                          const searchValue = newInputValue || '';
                          setPushSearchText(searchValue);
                          if (!searchValue.trim()) {
                            setFilteredPushNotifications(existingPushNotifications);
                          } else {
                            const filtered = existingPushNotifications.filter(push =>
                              (push.name && push.name.toLowerCase().includes(searchValue.toLowerCase())) ||
                              (push.message && push.message.toLowerCase().includes(searchValue.toLowerCase())) ||
                              (push.heading && push.heading.toLowerCase().includes(searchValue.toLowerCase()))
                            );
                            setFilteredPushNotifications(filtered);
                          }
                        }}
                        clearOnBlur={false}
                        loading={isLoadingExistingPush}
                        renderTags={() => null}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Rechercher une notification push..."
                            size="small"
                            autoComplete="off"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon sx={{ fontSize: '1rem' }} />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            <ListItemText
                              primary={option.name || option.heading}
                              secondary={
                                <>
                                  <Typography component="span" variant="body2">
                                    {option.message ? (option.message.substring(0, 50) + (option.message.length > 50 ? '...' : '')) : ''}
                                  </Typography>
                                  <br />
                                  <Typography component="span" variant="caption" color="text.secondary">
                                    {(option.dateAdded || option.dateModified) && new Date(option.dateAdded || option.dateModified).toLocaleDateString()}
                                  </Typography>
                                </>
                              }
                            />
                          </li>
                        )}
                        sx={{
                          bgcolor: '#f8f9fa',
                          borderRadius: 2,
                          fontFamily: 'Montserrat, Arial, sans-serif',
                          fontSize: 15
                        }}
                      />
                      {isLoadingExistingPush && (
                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                          <CircularProgress size={16} sx={{ mr: 1 }} />
                          <FormHelperText>Chargement des notifications push...</FormHelperText>
                        </Box>
                      )}
                      {!isLoadingExistingPush && filteredPushNotifications.length === 0 && (
                        <FormHelperText error>Aucune notification push disponible</FormHelperText>
                      )}
                      {form.selectedPushNotifications.filter(p => p.isExisting).length > 0 && (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                          {form.selectedPushNotifications.filter(p => p.isExisting).map((push) => (
                            <Chip
                              key={push.id}
                              label={push.name || push.heading}
                              color="secondary"
                              variant="outlined"
                              onDelete={() => {
                                setForm(prev => ({
                                  ...prev,
                                  selectedPushNotifications: prev.selectedPushNotifications.filter(sp => !(sp.isExisting && String(sp.id) === String(push.id)))
                                }));
                              }}
                              size="small"
                              sx={{
                                fontFamily: 'Montserrat, Arial, sans-serif',
                                fontSize: '0.75rem',
                                height: '24px'
                              }}
                            />
                          ))}
                        </Box>
                      )}
                    </FormControl>
                  </Box>
                </Box>

                {/* Selected Push Cards (like emails) */}
                <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {form.selectedPushNotifications.filter(p => p.isExisting).map((push, index) => (
                    <Box
                      key={push.id || index}
                      sx={{
                        ...customStyles.card,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 2,
                        borderLeft: '4px solid #9c27b0'
                      }}
                    >
                      <Box>
                        <Typography variant="h6" fontFamily="Montserrat, Arial, sans-serif" sx={{ color: '#1f2937' }}>
                          Push {index + 1}: {push.name || push.heading}
                        </Typography>
                        <Typography variant="body2" color="#6b7280" fontFamily="Montserrat, Arial, sans-serif" sx={{ fontSize: '0.875rem' }}>
                          {push.heading || push.name} - {push.message}
                        </Typography>
                      </Box>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleEditPushInCampaign(push)}
                        sx={{
                          fontFamily: 'Montserrat, Arial, sans-serif',
                          fontSize: '0.875rem',
                          padding: '0.25rem 0.75rem'
                        }}
                      >
                        <EditIcon sx={{ fontSize: '1rem', mr: 0.5 }} />
                        Éditer
                      </Button>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}

            {/* Section des emails sélectionnés - affichée pour les deux modes */}
            {form.selectedEmails.length > 0 && form.selectedContentTypes.includes('email') && (
              <Box sx={{ mt: 3 }}>
                <Typography variant="h6" gutterBottom fontFamily="Montserrat, Arial, sans-serif">
                  Emails sélectionnés :
                </Typography>
                {form.selectedEmails.map((email, index) => (
                  <Typography key={index} variant="body1" gutterBottom fontFamily="Montserrat, Arial, sans-serif">
                    • {email.name} {email.isExisting ? '(Existant)' : '(Nouveau)'}
                  </Typography>
                ))}

                {form.selectedEmails.map((email, idx) => (
                  <Accordion key={idx} sx={{ mb: 2 }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography fontFamily="Montserrat, Arial, sans-serif">Configuration de l'email: {email.name}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <pre style={{ overflow: 'auto', maxHeight: '300px', fontFamily: 'monospace' }}>
                        {JSON.stringify(email.config || {}, null, 2)}
                      </pre>
                    </AccordionDetails>
                  </Accordion>
                ))}

                {!mauticAvailable && (
                  <Alert severity="warning" sx={{ mt: 2 }}>
                    L'intégration Mautic n'est pas disponible car les identifiants ne sont pas configurés.
                  </Alert>
                )}
              </Box>
            )}

            {/* Section des notifications push sélectionnées  - affichée pour les deux modes */}
            {form.selectedPushNotifications.length > 0 && form.selectedContentTypes.includes('push') && (
              <Box sx={{ mt: 3 }}>
                <Typography variant="h6" gutterBottom fontFamily="Montserrat, Arial, sans-serif">
                  Notifications Push sélectionnées :
                </Typography>

                {form.selectedPushNotifications.map((push, idx) => (
                  <Accordion key={idx} sx={{ mb: 2 }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography fontFamily="Montserrat, Arial, sans-serif">Push: {push.name} {push.isExisting ? '(Existant)' : '(Nouveau)'}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography variant="subtitle2">Titre:</Typography>
                      <Typography variant="body2" paragraph>{push.heading}</Typography>
                      <Typography variant="subtitle2">Message:</Typography>
                      <Typography variant="body2" paragraph>{push.message}</Typography>
                      {!push.isExisting && (
                        <Box sx={{ mt: 1 }}>
                          <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            onClick={() => createSelectedPush(push)}
                            disabled={form.loadingPushIds.includes(push.name)}
                            startIcon={form.loadingPushIds.includes(push.name) ? <CircularProgress size={16} /> : null}
                          >
                            Créer maintenant
                          </Button>
                        </Box>
                      )}
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Box>
            )}
            {/* ── Panneaux Sociaux / SMS ─────────────────────────────────── */}
            {!isWhatsappTemplateMode && (['facebook', 'whatsapp', 'instagram', 'sms']).map(channel => {
              if (!form.selectedContentTypes.includes(channel)) return null;
              const channelConfig = {
                facebook: { label: 'Facebook Messenger', color: '#1877F2', emoji: '💬' },
                whatsapp: { label: 'WhatsApp', color: '#25D366', emoji: '📱' },
                instagram: { label: 'Instagram', color: '#E1306C', emoji: '📸' },
                sms: { label: 'SMS', color: '#F59E0B', emoji: '💬' }
              }[channel];
              const channelSuggestions = smsSuggestions.filter(s => s.channelType === channel);
              const channelSelected = form.selectedSmsMessages.filter(s => s.channelType === channel);
              const channelExisting = filteredSmsMessages.filter(s => {
                const cat = (s.category?.title || s.category?.name || s.category || '').toLowerCase();
                return cat === channel;
              });

              return (
                <Box key={channel} sx={{ mt: 4, mb: 2, borderLeft: `4px solid ${channelConfig.color}`, pl: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: channelConfig.color, mb: 2, fontFamily: 'Montserrat, Arial, sans-serif' }}>
                    {channelConfig.emoji} {channelConfig.label}
                  </Typography>

                  {/* Mode: Sélectionner ou Générer */}
                  {form.useExistingEmail ? (
                    /* ── Mode Sélectionner ─────── */
                    <Box>
                      <Box sx={{ display: 'flex', alignItems: 'end', gap: 2, mb: 2 }}>
                        <Box sx={{ flexGrow: 1 }}>
                          <Typography variant="body2" color="#868e96" mb={1} fontFamily="Montserrat, Arial, sans-serif">
                            Choisir un message {channelConfig.label}
                          </Typography>
                          <FormControl fullWidth>
                            <Autocomplete
                              multiple
                              disableCloseOnSelect
                              options={channelExisting}
                              getOptionLabel={(option) => option.name || ''}
                              isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                              value={form.selectedSmsMessages
                                .filter(m => (m.channelType || m.category?.title || m.category?.name || m.category || '').toLowerCase() === channel && m.isExisting)
                                .map(m => channelExisting.find(ex => String(ex.id) === String(m.id)) || m)
                              }
                              onChange={(_, newValue) => {
                                const selected = (newValue || []).map(m => ({ ...m, channelType: channel, isExisting: true }));
                                setForm(prev => {
                                  const keepOtherChannels = prev.selectedSmsMessages.filter(m => (m.channelType || '').toLowerCase() !== channel);
                                  const keepManualThisChannel = prev.selectedSmsMessages.filter(m => (m.channelType || '').toLowerCase() === channel && !m.isExisting);
                                  return { ...prev, selectedSmsMessages: [...keepOtherChannels, ...keepManualThisChannel, ...selected] };
                                });
                              }}
                              inputValue={smsSearchText}
                              onInputChange={(_, newInputValue, reason) => {
                                if (reason !== 'input') return;
                                handleSmsSearch(newInputValue || '');
                              }}
                              clearOnBlur={false}
                              loading={isLoadingExistingSms}
                              renderTags={() => null}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder={`Rechercher un message ${channelConfig.label}...`}
                                  size="small"
                                  autoComplete="off"
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <SearchIcon sx={{ fontSize: '1rem' }} />
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              )}
                              renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                  <ListItemText
                                    primary={option.name}
                                    secondary={
                                      <>
                                        <Typography component="span" variant="body2">
                                          {(option.message || option.text || '').substring(0, 60)}
                                          {(option.message || option.text || '').length > 60 ? '...' : ''}
                                        </Typography>
                                        <br />
                                        <Typography component="span" variant="caption" color="text.secondary">
                                          {(option.dateAdded || option.dateModified) && new Date(option.dateAdded || option.dateModified).toLocaleDateString()}
                                        </Typography>
                                      </>
                                    }
                                  />
                                </li>
                              )}
                              sx={{
                                bgcolor: '#f8f9fa',
                                borderRadius: 2,
                                fontFamily: 'Montserrat, Arial, sans-serif',
                                fontSize: 15
                              }}
                            />
                            {isLoadingExistingSms && (
                              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                <CircularProgress size={16} sx={{ mr: 1 }} />
                                <FormHelperText>Chargement des messages...</FormHelperText>
                              </Box>
                            )}
                            {!isLoadingExistingSms && channelExisting.length === 0 && (
                              <FormHelperText error>Aucun message {channelConfig.label} disponible</FormHelperText>
                            )}
                            {form.selectedSmsMessages.filter(m => (m.channelType || '').toLowerCase() === channel && m.isExisting).length > 0 && (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                                {form.selectedSmsMessages
                                  .filter(m => (m.channelType || '').toLowerCase() === channel && m.isExisting)
                                  .map((m) => (
                                    <Chip
                                      key={`${channel}-${m.id}`}
                                      label={m.name}
                                      variant="outlined"
                                      onDelete={() => {
                                        setForm(prev => ({
                                          ...prev,
                                          selectedSmsMessages: prev.selectedSmsMessages.filter(sm => !(String(sm.id) === String(m.id) && (sm.channelType || '').toLowerCase() === channel && sm.isExisting))
                                        }));
                                      }}
                                      size="small"
                                      sx={{
                                        fontFamily: 'Montserrat, Arial, sans-serif',
                                        fontSize: '0.75rem',
                                        height: '24px',
                                        borderColor: channelConfig.color,
                                        color: channelConfig.color
                                      }}
                                    />
                                  ))}
                              </Box>
                            )}
                          </FormControl>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    /* ── Mode Générer par IA ───── */
                    <Box>
                      <Button
                        onClick={() => suggestSmsMessages(channel)}
                        disabled={Boolean(smsLoadingByChannel[channel]) || !form.objectif.trim()}
                        startIcon={smsLoadingByChannel[channel] ? <CircularProgress size={16} /> : <AutoAwesomeIcon />}
                        sx={{ ...customStyles.btn, backgroundColor: channelConfig.color, color: '#fff', mb: 2, '&:hover': { backgroundColor: channelConfig.color, opacity: 0.85 } }}
                      >
                        Générer des messages {channelConfig.label}
                      </Button>
                      {channelSuggestions.length > 0 && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                          {channelSuggestions.map((sms, idx) => {
                            const isSelected = form.selectedSmsMessages.some(s => s.name === sms.name && s.channelType === channel);
                            const selectedSms = form.selectedSmsMessages.find(s => s.name === sms.name && s.channelType === channel);
                            const isCreated = selectedSms?.isExisting === true;
                            return (
                              <Box key={idx} onClick={() => handleSelectSmsMessage(sms)} sx={{ ...customStyles.card, cursor: 'pointer', border: isSelected ? `2px solid ${channelConfig.color}` : '1px solid #e2e8f0', transition: 'all 0.2s' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                  <Typography variant="subtitle2" sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 600 }}>{sms.name}</Typography>
                                  <Box sx={{ display: 'flex', gap: 1 }}>
                                    {isSelected && <Chip label="Sélectionné" color="info" size="small" sx={{ fontSize: '0.7rem', height: '20px' }} />}
                                    <Chip label={isCreated ? "Créé" : "Nouveau"} size="small" sx={{ bgcolor: isCreated ? '#10B981' : channelConfig.color, color: '#fff', fontSize: '0.7rem', height: '20px' }} />
                                  </Box>
                                </Box>
                                <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Montserrat, Arial, sans-serif', mb: 1 }}>{sms.message}</Typography>
                                {/* Boutons Créer + Éditer pour SMS/Social IA */}
                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }} onClick={e => e.stopPropagation()}>
                                  {!isCreated && (
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      onClick={e => { e.stopPropagation(); createSelectedSms(sms); }}
                                      disabled={form.loadingSmsIds.includes(sms.name)}
                                      startIcon={form.loadingSmsIds.includes(sms.name) ? <CircularProgress size={14} /> : null}
                                      sx={{ fontSize: '0.75rem', borderColor: channelConfig.color, color: channelConfig.color }}
                                    >
                                      Créer le message
                                    </Button>
                                  )}
                                  <Tooltip
                                    title={!isCreated ? "Créez d'abord ce message pour pouvoir l'éditer" : "Modifier ce message"}
                                    arrow
                                  >
                                    <span>
                                      <Button
                                        size="small"
                                        variant="outlined"
                                        disabled={!isCreated}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (isCreated && selectedSms) {
                                            handleEditSmsInCampaign(selectedSms);
                                          }
                                        }}
                                        startIcon={<EditIcon sx={{ fontSize: '0.85rem' }} />}
                                        sx={{
                                          fontSize: '0.75rem',
                                          borderColor: isCreated ? channelConfig.color : '#9ca3af',
                                          color: isCreated ? channelConfig.color : '#9ca3af',
                                          opacity: isCreated ? 1 : 0.6
                                        }}
                                      >
                                        Éditer
                                      </Button>
                                    </span>
                                  </Tooltip>
                                  {!isCreated && (
                                    <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontStyle: 'italic', fontSize: '0.7rem' }}>
                                      Créez ce message pour pouvoir l'éditer
                                    </Typography>
                                  )}
                                </Box>
                              </Box>
                            );
                          })}
                        </Box>
                      )}
                    </Box>
                  )}

                  {/* Messages sélectionnés pour ce canal */}
                  {channelSelected.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="caption" sx={{ color: '#6b7280', fontWeight: 600, textTransform: 'uppercase', fontFamily: 'Montserrat, Arial, sans-serif' }}>Messages sélectionnés :</Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                        {channelSelected.map((sms, idx) => {
                          const smsIsCreated = sms.isExisting === true;
                          return (
                            <Box key={idx} sx={{ ...customStyles.card, display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1.5, borderLeft: `3px solid ${channelConfig.color}` }}>
                              <Box>
                                <Typography variant="subtitle2" sx={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 600 }}>{sms.name}</Typography>
                                <Typography variant="caption" color="text.secondary">{(sms.message || '').substring(0, 60)}{(sms.message || '').length > 60 ? '...' : ''}</Typography>
                                {!smsIsCreated && (
                                  <Typography variant="caption" sx={{ display: 'block', color: '#9ca3af', fontStyle: 'italic', fontSize: '0.65rem' }}>
                                    Créez ce message pour pouvoir l'éditer
                                  </Typography>
                                )}
                              </Box>
                              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                <Tooltip title={!smsIsCreated ? "Créez d'abord ce message pour pouvoir l'éditer" : "Modifier ce message"} arrow>
                                  <span>
                                    <Button
                                      size="small"
                                      disabled={!smsIsCreated}
                                      onClick={() => smsIsCreated && handleEditSmsInCampaign(sms)}
                                      sx={{ minWidth: 0, p: '2px 8px', color: smsIsCreated ? channelConfig.color : '#9ca3af', fontSize: '0.75rem', opacity: smsIsCreated ? 1 : 0.5 }}
                                      startIcon={<EditIcon sx={{ fontSize: '0.85rem' }} />}
                                    >
                                      Éditer
                                    </Button>
                                  </span>
                                </Tooltip>
                                <Button size="small" onClick={() => handleSelectSmsMessage(sms)} sx={{ minWidth: 0, p: '2px 8px', color: '#ef4444', fontSize: '0.75rem' }}>✕</Button>
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  )}
                </Box>
              );
            })}
          </Box>
        );
      case 3:
        return (
          <Box>
            <Typography sx={customStyles.stepTitle}>
              Planification de la Campagne
            </Typography>

            {/* Switch pour activer la planification - style identique au template HTML */}
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2
            }}>
              <Typography sx={{
                fontFamily: 'Montserrat, Arial, sans-serif',
                fontWeight: 500,
                color: '#1f2937'
              }}>
                Activer la planification
              </Typography>
              <FormControlLabel
                control={
                  <Switch
                    checked={form.isPublished}
                    onChange={handlePublishToggle}
                    sx={{
                      '& .MuiSwitch-switchBase.Mui-checked': {
                        color: '#007B8A',
                        '& + .MuiSwitch-track': {
                          backgroundColor: '#007B8A',
                        },
                      },
                    }}
                  />
                }
                label=""
                sx={{ m: 0 }}
              />
            </Box>

            {/* Panneau de planification - affiché seulement si activé */}
            {form.isPublished && (
              <Box sx={{
                mt: 3,
                pt: 3,
                borderTop: '1px solid #e2e8f0',
                display: 'flex',
                flexDirection: 'column',
                gap: 2
              }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2" color="#868e96" mb={1} fontFamily="Montserrat, Arial, sans-serif">
                      Date de début
                    </Typography>
                    <TextField
                      fullWidth
                      type="datetime-local"
                      value={form.startDate}
                      onChange={(e) => handleDateChange('startDate', e)}
                      sx={{
                        bgcolor: '#f8f9fa',
                        borderRadius: 2,
                        fontFamily: 'Montserrat, Arial, sans-serif',
                        fontSize: 15,
                        '& .MuiOutlinedInput-root': {
                          fontFamily: 'Montserrat, Arial, sans-serif'
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography variant="body2" color="#868e96" mb={1} fontFamily="Montserrat, Arial, sans-serif">
                      Date de fin (optionnel)
                    </Typography>
                    <TextField
                      fullWidth
                      type="datetime-local"
                      value={form.endDate}
                      onChange={(e) => handleDateChange('endDate', e)}
                      sx={{
                        bgcolor: '#f8f9fa',
                        borderRadius: 2,
                        fontFamily: 'Montserrat, Arial, sans-serif',
                        fontSize: 15,
                        '& .MuiOutlinedInput-root': {
                          fontFamily: 'Montserrat, Arial, sans-serif'
                        }
                      }}
                      error={form.startDate && form.endDate && new Date(form.endDate) <= new Date(form.startDate)}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="body2" color="#868e96" mb={1} fontFamily="Montserrat, Arial, sans-serif">
                      Fuseau horaire
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        value={form.timezone}
                        onChange={handleTimezoneChange}
                        sx={{
                          bgcolor: '#f8f9fa',
                          borderRadius: 2,
                          fontFamily: 'Montserrat, Arial, sans-serif',
                          fontSize: 15
                        }}
                      >
                        <MenuItem value="Europe/Paris" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          (GMT+02:00) Paris
                        </MenuItem>
                        <MenuItem value="America/New_York" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          (GMT-04:00) New York
                        </MenuItem>
                        <MenuItem value="Asia/Tokyo" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          (GMT+09:00) Tokyo
                        </MenuItem>
                        <MenuItem value="UTC" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC
                        </MenuItem>
                        <MenuItem value="+01:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC+1 (Paris)
                        </MenuItem>
                        <MenuItem value="+02:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC+2 (Helsinki)
                        </MenuItem>
                        <MenuItem value="+03:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC+3 (Moscou)
                        </MenuItem>
                        <MenuItem value="+04:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC+4 (Dubaï)
                        </MenuItem>
                        <MenuItem value="+05:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC+5 (Karachi)
                        </MenuItem>
                        <MenuItem value="+05:30" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC+5:30 (New Delhi)
                        </MenuItem>
                        <MenuItem value="+08:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC+8 (Pékin)
                        </MenuItem>
                        <MenuItem value="+09:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC+9 (Tokyo)
                        </MenuItem>
                        <MenuItem value="+10:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC+10 (Sydney)
                        </MenuItem>
                        <MenuItem value="-05:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC-5 (New York)
                        </MenuItem>
                        <MenuItem value="-06:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC-6 (Chicago)
                        </MenuItem>
                        <MenuItem value="-07:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC-7 (Denver)
                        </MenuItem>
                        <MenuItem value="-08:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC-8 (Los Angeles)
                        </MenuItem>
                        <MenuItem value="-10:00" sx={{ fontFamily: 'Montserrat, Arial, sans-serif' }}>
                          UTC-10 (Hawaii)
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>
        );
      case 4:
        return (
          <Box>
            <Typography sx={customStyles.stepTitle}>
              Construire le Workflow
            </Typography>

            {isWhatsappTemplateMode && (
              <Box sx={{ ...customStyles.card, borderLeft: '4px solid #25D366' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#166534', fontFamily: 'Montserrat, Arial, sans-serif', mb: 1 }}>
                  Workflow WhatsApp Template
                </Typography>
                <Typography variant="body2" sx={{ color: '#1f2937', fontFamily: 'Montserrat, Arial, sans-serif' }}>
                  Segment: <b>{selectedWhatsappSegment?.name || 'Non sélectionné'}</b>
                </Typography>
                <Typography variant="body2" sx={{ color: '#1f2937', fontFamily: 'Montserrat, Arial, sans-serif', mt: 0.5 }}>
                  Template: <b>{selectedWhatsappTemplate?.name || 'Non sélectionné'}</b>
                </Typography>
                <Typography variant="body2" sx={{ color: '#6b7280', fontFamily: 'Montserrat, Arial, sans-serif', mt: 1.5 }}>
                  Cette campagne sera envoyée via Discussions (Inbox API) au moment de la validation finale, sans création de workflow Mautic.
                </Typography>
              </Box>
            )}

            {!isWhatsappTemplateMode && (
            <>

            {/* Sélecteur d'onglet - style identique au template HTML */}
            <Box sx={{
              display: 'flex',
              borderBottom: '1px solid #e2e8f0',
              mb: 2
            }}>

              <Button
                variant="text"
                onClick={() => handleWorkflowModeChange('nl')}
                sx={{
                  ...customStyles.stepButton,
                  ...(form.workflowMode === 'nl' && {
                    color: '#007B8A',
                    borderBottom: '2px solid #007B8A',
                    borderRadius: 0
                  }),
                  fontFamily: 'Montserrat, Arial, sans-serif',
                  fontWeight: 500,
                  px: 3,
                  py: 1.5
                }}
              >
                Décrire avec l'IA
              </Button>
            </Box>



            {/* Panneau Langage Naturel */}
            {form.workflowMode === 'nl' && (
              <Box>
                <Typography variant="body2" color="#6b7280" mb={2} fontFamily="Montserrat, Arial, sans-serif" sx={{ fontSize: '0.875rem' }}>
                  Décrivez votre séquence ou cliquez sur "Suggérer" pour que l'IA la génère pour vous.
                </Typography>

                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2" color="#868e96" mb={1} fontFamily="Montserrat, Arial, sans-serif">
                      Description du workflow
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      rows={10}
                      value={form.workflowDescription}
                      onChange={(e) => setForm(prev => ({ ...prev, workflowDescription: e.target.value }))}
                      placeholder="- Envoyer l'email 'Bienvenue'..."
                      sx={{
                        bgcolor: '#f8f9fa',
                        borderRadius: 2,
                        fontFamily: 'Consolas, Monaco, monospace',
                        fontSize: '0.875rem',
                        '& .MuiOutlinedInput-root': {
                          fontFamily: 'Consolas, Monaco, monospace'
                        }
                      }}
                    />
                    <Button
                      onClick={generateCampaignWorkflow}
                      disabled={
                        loading ||
                        form.selectedSegments.length === 0 ||
                        (
                          form.selectedEmails.length === 0 &&
                          form.selectedPushNotifications.length === 0 &&
                          form.selectedSmsMessages.length === 0
                        )
                      }
                      startIcon={loading ? <CircularProgress size={20} /> : <AutoAwesomeIcon />}
                      sx={{
                        ...customStyles.btn,
                        ...customStyles.btnSuggest,
                        fontFamily: 'Montserrat, Arial, sans-serif',
                        mt: 2
                      }}
                    >
                      Suggérer un workflow
                    </Button>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    {/* Conteneur de prévisualisation du workflow */}
                    <Box sx={{
                      ...customStyles.card,
                      mt: 2
                    }}>
                      <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 2
                      }}>
                        <Typography variant="subtitle1" sx={{
                          fontFamily: 'Montserrat, Arial, sans-serif',
                          fontWeight: 600,
                          color: '#1f2937'
                        }}>
                          Prévisualisation du Json
                        </Typography>
                        <IconButton
                          size="small"
                          sx={{
                            color: '#6b7280',
                            '&:hover': { bgcolor: '#f1f5f9' }
                          }}
                        >
                          <CodeIcon sx={{ fontSize: '1.25rem' }} />
                        </IconButton>
                      </Box>

                      {/* Vue Visuelle (par défaut) */}
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {form.workflow ? (
                          <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            p: 1.5,
                            bgcolor: '#f1f5f9',
                            borderRadius: 1
                          }}>
                            <CheckCircleIcon sx={{ fontSize: '1.25rem', color: '#6b7280' }} />
                            <Box>
                              <Typography variant="body2" sx={{
                                fontFamily: 'Montserrat, Arial, sans-serif',
                                fontWeight: 600,
                                color: '#1f2937',
                                fontSize: '0.875rem'
                              }}>
                                Workflow généré
                              </Typography>
                              <Typography variant="caption" sx={{
                                color: '#6b7280',
                                fontFamily: 'Montserrat, Arial, sans-serif'
                              }}>
                                {form.workflow.length > 100 ? form.workflow.substring(0, 100) + '...' : form.workflow}
                              </Typography>
                            </Box>
                          </Box>
                        ) : (
                          <Typography variant="body2" color="#9ca3af" fontFamily="Montserrat, Arial, sans-serif" sx={{ fontSize: '0.875rem' }}>
                            La prévisualisation de votre workflow s'affichera ici...
                          </Typography>
                        )}
                      </Box>

                      {/* Vue JSON (cachée par défaut) */}
                      {(form.visualGraph || form.campaignJson) && (
                        <Box sx={{
                          mt: 2,
                          bgcolor: '#1f2937',
                          color: 'white',
                          borderRadius: 1,
                          p: 2,
                          overflow: 'auto',
                          maxHeight: '200px'
                        }}>
                          <pre style={{
                            fontFamily: 'Consolas, Monaco, monospace',
                            fontSize: '0.75rem',
                            margin: 0
                          }}>
                            {JSON.stringify(form.visualGraph || form.campaignJson, null, 2)}
                          </pre>
                        </Box>
                      )}
                    </Box>

                    {/* Description globale du workflow - vue textuelle détaillée */}
                    <Box sx={{
                      ...customStyles.card,
                      mt: 2
                    }}>
                      <Typography variant="subtitle1" sx={{
                        fontFamily: 'Montserrat, Arial, sans-serif',
                        fontWeight: 600,
                        color: '#1f2937'
                      }}>
                        Description globale du workflow
                      </Typography>
                      {form.workflow ? (
                        <Typography
                          variant="body2"
                          sx={{
                            mt: 1.5,
                            whiteSpace: 'pre-wrap',
                            fontFamily: 'Montserrat, Arial, sans-serif',
                            color: '#1f2937',
                            fontSize: '0.9rem'
                          }}
                        >
                          {form.workflow}
                        </Typography>
                      ) : (
                        <Typography
                          variant="body2"
                          color="#9ca3af"
                          sx={{
                            mt: 1.5,
                            fontFamily: 'Montserrat, Arial, sans-serif',
                            fontSize: '0.875rem'
                          }}
                        >
                          La description détaillée de votre campagne s'affichera ici une fois le workflow généré. Elle expliquera, étape par étape, toutes les actions (ex: si l'email est ouvert ou non, quel email est envoyé ensuite, changements de segments, délais, conditions, etc.).
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}
            </>
            )}
          </Box>
        );
      case 5:
        return (
          <Box>
            <Typography sx={customStyles.stepTitle}>
              Résumé et Finalisation
            </Typography>

            {/* Résumé dans un style identique au template HTML */}
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              p: 3,
              border: '1px solid #e2e8f0',
              borderRadius: 2,
              bgcolor: '#f8fafc'
            }}>
              <Box sx={{ pb: 2, borderBottom: '1px solid #e2e8f0' }}>
                <Typography variant="subtitle2" sx={{
                  fontFamily: 'Montserrat, Arial, sans-serif',
                  fontWeight: 600,
                  color: '#4b5563'
                }}>
                  Objectif & Canal
                </Typography>
                <Typography sx={{
                  color: '#1f2937',
                  mt: 0.5,
                  fontFamily: 'Montserrat, Arial, sans-serif'
                }}>
                  {form.objectif || <span style={{ color: '#bdbdbd' }}>Non défini</span>} | Canal: {form.canal === 'mautic_email' ? 'Email' : form.canal === 'sms' ? 'SMS' : 'Non défini'}
                </Typography>
                <Typography sx={{
                  color: '#1f2937',
                  mt: 0.5,
                  fontFamily: 'Montserrat, Arial, sans-serif'
                }}>
                  Nom de la campagne: {(form.campaignJson?.campaign?.name) || customCampaignName || campaignName || <span style={{ color: '#bdbdbd' }}>Non défini</span>}
                </Typography>
              </Box>

              <Box sx={{ pb: 2, borderBottom: '1px solid #e2e8f0' }}>
                <Typography variant="subtitle2" sx={{
                  fontFamily: 'Montserrat, Arial, sans-serif',
                  fontWeight: 600,
                  color: '#4b5563'
                }}>
                  Cible
                </Typography>
                <Typography sx={{
                  color: '#1f2937',
                  mt: 0.5,
                  fontFamily: 'Montserrat, Arial, sans-serif'
                }}>
                  {form.selectedSegments?.length > 0 ?
                    form.selectedSegments.map(s => s.name).join(', ') :
                    <span style={{ color: '#bdbdbd' }}>Non défini</span>
                  }
                </Typography>
              </Box>

              <Box sx={{ pb: 2, borderBottom: '1px solid #e2e8f0' }}>
                <Typography variant="subtitle2" sx={{
                  fontFamily: 'Montserrat, Arial, sans-serif',
                  fontWeight: 600,
                  color: '#4b5563'
                }}>
                  Contenu
                </Typography>
                <Typography sx={{
                  color: '#1f2937',
                  mt: 0.5,
                  fontFamily: 'Montserrat, Arial, sans-serif'
                }}>
                  {isWhatsappTemplateMode ? (
                    <>
                      Segment: {selectedWhatsappSegment?.name || 'Non sélectionné'} | Template WhatsApp: {selectedWhatsappTemplate?.name || 'Non sélectionné'}
                    </>
                  ) : (() => {
                    const emails = (form.selectedEmails || []).map(e => e.name);
                    const pushes = (form.selectedPushNotifications || []).map(p => p.name || p.heading);
                    const smsList = (form.selectedSmsMessages || []).map(m => m.name);
                    const all = [...emails, ...pushes, ...smsList].filter(Boolean);
                    if (all.length === 0) {
                      return <span style={{ color: '#bdbdbd' }}>Non défini</span>;
                    }
                    return all.join(', ');
                  })()}
                </Typography>
              </Box>

              <Box sx={{ pb: 2, borderBottom: '1px solid #e2e8f0' }}>
                <Typography variant="subtitle2" sx={{
                  fontFamily: 'Montserrat, Arial, sans-serif',
                  fontWeight: 600,
                  color: '#4b5563'
                }}>
                  Workflow
                </Typography>
                <Typography sx={{
                  color: '#1f2937',
                  mt: 0.5,
                  fontFamily: 'Montserrat, Arial, sans-serif',
                  whiteSpace: 'pre-wrap'
                }}>
                  {isWhatsappTemplateMode
                    ? (form.workflow || 'Campagne WhatsApp template: envoi direct via Discussions.')
                    : (form.workflow || <span style={{ color: '#bdbdbd' }}>Non défini</span>)}
                </Typography>
              </Box>

              <Box>
                <Typography variant="subtitle2" sx={{
                  fontFamily: 'Montserrat, Arial, sans-serif',
                  fontWeight: 600,
                  color: '#4b5563'
                }}>
                  Planification
                </Typography>
                <Typography sx={{
                  color: '#1f2937',
                  mt: 0.5,
                  fontFamily: 'Montserrat, Arial, sans-serif'
                }}>
                  {form.isPublished ? (
                    (() => {
                      const deb = formatDisplayDate(form.startDate);
                      const fin = formatDisplayDate(form.endDate);
                      const parts = [];
                      parts.push(`Début: ${deb || 'Non défini'}`);
                      parts.push(`Fin: ${fin || 'Non définie'}`);
                      parts.push(`Fuseau: ${form.timezone || 'UTC'}`);
                      return `Campagne planifiée. ${parts.join(', ')}.`;
                    })()
                  ) : (
                    'Campagne non planifiée (envoi manuel ou lancement direct).'
                  )}
                </Typography>
              </Box>
            </Box>
          </Box>
        );
      default:
        return null;
    }
  };

  // Fonction pour vérifier si l'étape actuelle est valide
  const isStepValid = (step) => {
    switch (step) {
      case 0: // Étape Objectif
        return form.objectif.trim() !== "";
      case 1: // Étape Cible
        return form.selectedSegments.length > 0;
      case 2: // Étape Contenu
        if (isWhatsappTemplateMode) {
          return Boolean(selectedWhatsappTemplate && selectedWhatsappSegment);
        }
        return (
          form.selectedEmails.length > 0 ||
          form.selectedPushNotifications.length > 0 ||
          form.selectedSmsMessages.length > 0
        );
      case 3: // Étape Timing
        return true; // Le timing n'est pas obligatoire
      case 4: // Étape Workflow
        if (isWhatsappTemplateMode) {
          return Boolean(selectedWhatsappTemplate && selectedWhatsappSegment);
        }
        return form.workflow.trim() !== "" && (form.campaignJson !== null || form.visualGraph !== null);
      case 5: // Étape Résumé
        if (isWhatsappTemplateMode) {
          return form.selectedSegments.length > 0 && Boolean(selectedWhatsappTemplate && selectedWhatsappSegment);
        }
        return (
          form.selectedSegments.length > 0 &&
          (
            form.selectedEmails.length > 0 ||
            form.selectedPushNotifications.length > 0 ||
            form.selectedSmsMessages.length > 0
          )
        );
      default:
        return false;
    }
  };

  // Détermine l'étape maximale atteignable en validant séquentiellement depuis le début
  const getMaxReachableStep = () => {
    let maxReachable = 0;
    for (let i = 0; i < steps.length - 1; i++) {
      if (isStepValid(i)) {
        maxReachable = i + 1; // l'étape suivante devient atteignable
      } else {
        break; // on s'arrête dès que l'étape courante n'est pas valide
      }
    }
    return maxReachable;
  };

  // Fonction pour passer à l'étape suivante
  const handleNext = () => {
    if (isStepValid(activeStep)) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      // Afficher un message d'erreur spécifique à l'étape
      switch (activeStep) {
        case 0:
          setError('Veuillez définir un objectif avant de continuer.');
          break;
        case 1:
          setError('Veuillez sélectionner au moins un segment avant de continuer.');
          break;
        case 2:
          setError(isWhatsappTemplateMode
            ? 'Veuillez sélectionner un segment et un template WhatsApp avant de continuer.'
            : 'Veuillez sélectionner au moins un contenu (email, notification push ou message) avant de continuer.');
          break;
        case 4:
          setError(isWhatsappTemplateMode
            ? 'Veuillez sélectionner un segment et un template WhatsApp.'
            : 'Veuillez générer un workflow avant de continuer.');
          break;
        default:
          setError('Veuillez compléter cette étape avant de continuer.');
      }
    }
  };

  // Fonction pour revenir à l'étape précédente
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  // Fonction pour fermer les alertes
  const handleCloseAlert = () => {
    setError('');
    setSuccess('');
  };

  // Fonction pour créer la campagne directement à partir du JSON généré
  const handleCreateCampaign = async () => {
    if (isWhatsappTemplateMode) {
      if (!selectedWhatsappTemplate) {
        setError('Veuillez sélectionner un template WhatsApp.');
        return;
      }
      if (!selectedWhatsappSegment) {
        setError('Veuillez sélectionner un segment pour la campagne WhatsApp.');
        return;
      }

      setLaunchingWhatsappTemplateCampaign(true);
      setError('');
      setSuccess('');
      try {
        const contactsPayload = await fetchMauticContactsBySegment({
          segmentName: selectedWhatsappSegment.name || '',
          segmentAlias: selectedWhatsappSegment.alias || '',
        });
        const templatePayload = buildTemplateSendPayload(selectedWhatsappTemplate);
        const resp = await launchWhatsappTemplateCampaign({
          brand: userCredentials.brand,
          templateName: templatePayload.templateName || selectedWhatsappTemplate.name,
          templateLanguage: templatePayload.templateLanguage || selectedWhatsappTemplate.language || 'en',
          templateComponents: templatePayload.templateComponents,
          contactsPayload,
        });
        const campaignId = resp?.campaignId || resp?.campaign_id || 'N/A';
        const successMsg = resp?.message || 'Campagne WhatsApp lancée avec succès.';
        setSuccess(successMsg);
        navigate('/campagne/succes', {
          state: {
            campaignId,
            campaignName: `WhatsApp - ${selectedWhatsappTemplate.name}`,
            message: successMsg,
          },
        });
      } catch (err) {
        setError(err?.message || "Erreur lors du lancement de la campagne WhatsApp.");
      } finally {
        setLaunchingWhatsappTemplateCampaign(false);
      }
      return;
    }

    // Vérifier que nous avons un JSON de campagne (soit généré par IA, soit créé visuellement)
    const campaignData = form.visualGraph || form.campaignJson;
    if (!campaignData) {
      setError('Aucun workflow généré. Veuillez d\'abord générer un workflow ou créer un schéma visuel.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      console.log('Création de campagne avec le JSON généré:', campaignData);

      // Ajuster les dates dans le JSON de la campagne si nécessaire
      let adjustedCampaignJson = { ...campaignData };

      // Ajuster les dates de la campagne si elles existent
      if (form.isPublished && adjustedCampaignJson.campaign && adjustedCampaignJson.campaign.publishUp) {
        adjustedCampaignJson.campaign.publishUp = adjustDateForTimezone(adjustedCampaignJson.campaign.publishUp, form.timezone);
        console.log(`Date de début ajustée : ${adjustedCampaignJson.campaign.publishUp}`);
      }

      if (form.isPublished && adjustedCampaignJson.campaign && adjustedCampaignJson.campaign.publishDown) {
        adjustedCampaignJson.campaign.publishDown = adjustDateForTimezone(adjustedCampaignJson.campaign.publishDown, form.timezone);
        console.log(`Date de fin ajustée : ${adjustedCampaignJson.campaign.publishDown}`);
      }

      // Ajuster également les dates des événements si nécessaire
      if (form.isPublished && adjustedCampaignJson.campaign && adjustedCampaignJson.campaign.events) {
        adjustedCampaignJson.campaign.events.forEach(event => {
          // Ajuster la date de déclenchement si elle existe
          if (event.triggerDate) {
            const oldDate = event.triggerDate;
            event.triggerDate = adjustDateForTimezone(event.triggerDate, form.timezone);
            console.log(`Événement - date de déclenchement ajustée: ${oldDate} -> ${event.triggerDate}`);
          }

          // Ajuster les dates de timing si elles existent
          if (event.triggerMode === 'date' && event.triggerDate) {
            const oldDate = event.triggerDate;
            event.triggerDate = adjustDateForTimezone(event.triggerDate, form.timezone);
            console.log(`Événement - mode date ajusté: ${oldDate} -> ${event.triggerDate}`);
          }

          // Vérifier les propriétés spécifiques qui pourraient contenir des dates
          for (const prop in event) {
            if (typeof event[prop] === 'string' &&
              (event[prop].includes('-') || event[prop].includes(':')) &&
              /\d{4}-\d{2}-\d{2}/.test(event[prop])) {
              try {
                const oldDate = event[prop];
                event[prop] = adjustDateForTimezone(event[prop], form.timezone);
                console.log(`Événement - propriété date ajustée: ${prop}: ${oldDate} -> ${event[prop]}`);
              } catch (err) {
                console.log(`Erreur lors de l'ajustement de la date pour la propriété ${prop}:`, err);
              }
            }
          }
        });
      }

      // S'assurer que les dates sont présentes si planifié, même si absentes initialement
      if (form.isPublished && adjustedCampaignJson.campaign) {
        const startAdj = adjustDateForTimezone(form.startDate, form.timezone);
        const endAdj = adjustDateForTimezone(form.endDate, form.timezone);
        if (!adjustedCampaignJson.campaign.publishUp && startAdj) adjustedCampaignJson.campaign.publishUp = startAdj;
        if (!adjustedCampaignJson.campaign.publishDown && endAdj) adjustedCampaignJson.campaign.publishDown = endAdj;
      }

      // Appel à l'API pour créer la campagne avec les identifiants Mautic du backend
      const response = await api.post(
        '/campaigns/create-from-json',
        {
          campaign_json: adjustedCampaignJson,
          mautic_url: userCredentials.mautic_url,
          mautic_username: userCredentials.mautic_username,
          mautic_password: userCredentials.mautic_password
        }
      );

      if (response.data.success) {
        const campaignId = response.data.campaign_id || response.data.data?.campaign?.id || 'ID non disponible';
        setSuccess(`Campagne créée avec succès! (ID: ${campaignId})`);

        // Rediriger vers une page de succès
        navigate('/campagne/succes', {
          state: {
            campaignId,
            campaignName: adjustedCampaignJson?.campaign?.name || customCampaignName || 'Nouvelle campagne',
            message: `Campagne créée avec succès! (ID: ${campaignId})`
          }
        });
      } else {
        setError('veuillez regénérer le workflow s\'il vous plaît');
      }
    } catch (err) {
      console.error('Erreur lors de la création de la campagne:', err);
      setError('veuillez regénérer le workflow s\'il vous plaît');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={customStyles.root}>
      <Box sx={customStyles.container}>
        {/* Header */}
        <Box sx={customStyles.header}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconButton
              onClick={() => navigate(-1)}
              sx={{
                color: '#6b7280',
                '&:hover': {
                  backgroundColor: 'rgba(0, 123, 138, 0.1)',
                  color: '#007B8A'
                }
              }}
              title="Retour à la page précédente"
            >
              <ArrowBackIcon />
            </IconButton>
            <Box>
              <Typography sx={customStyles.headerTitle}>
                Assistant de Planification de Campagne
              </Typography>
              <Typography sx={customStyles.headerSubtitle}>
                Suivez les étapes pour construire un plan de campagne solide.
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Navigation Steps */}
        <Box sx={customStyles.navigation}>
          {steps.map((step, index) => {
            const maxReachable = getMaxReachableStep();
            const isClickable = index <= maxReachable; // on ne peut pas aller au-delà
            const isActive = activeStep === index;
            return (
              <Button
                key={step}
                disabled={!isClickable}
                sx={{
                  ...customStyles.stepButton,
                  ...(isActive && { color: '#fff', backgroundColor: '#007B8A' }),
                  ...(!isClickable && {
                    color: '#9ca3af',
                    cursor: 'not-allowed',
                    opacity: 0.6,
                    borderColor: '#e5e7eb'
                  })
                }}
                onClick={() => isClickable && setActiveStep(index)}
              >
                {index + 1}. {step}
              </Button>
            );
          })}
        </Box>

        {/* Content */}
        <Box sx={customStyles.content}>
          {renderStepContent()}

          {/* Navigation Buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 8 }}>
            <Button
              variant="outlined"
              onClick={handleBack}
              disabled={activeStep === 0}
              sx={{
                ...customStyles.btn,
                ...customStyles.btnSecondary,
                borderRadius: 2,
                fontWeight: 600
              }}
            >
              Retour
            </Button>
            <Button
              variant="contained"
              onClick={activeStep === steps.length - 1 ? handleCreateCampaign : handleNext}
              disabled={!isStepValid(activeStep) || (activeStep === steps.length - 1 && (loading || launchingWhatsappTemplateCampaign))}
              startIcon={activeStep === steps.length - 1 && (loading || launchingWhatsappTemplateCampaign) ? <CircularProgress size={20} color="inherit" /> : null}
              sx={{
                ...customStyles.btn,
                ...customStyles.btnPrimary,
                borderRadius: 2,
                fontWeight: 600
              }}
            >
              {activeStep === steps.length - 1
                ? ((loading || launchingWhatsappTemplateCampaign) ? 'Création en cours...' : 'Terminer')
                : 'Suivant'}
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Messages d'erreur et de succès */}
      <Snackbar open={!!error} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>

      <Snackbar open={!!success} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%' }}>
          {success}
        </Alert>
      </Snackbar>

      {emailEditorOpen && (
        <EmailAssistant
          open={emailEditorOpen}
          onClose={() => {
            setEmailEditorOpen(false);
            setEmailEditorInitialMjml(null);
            setEmailEditorInitialBuilderJson(null);
            setEmailEditorInitialLastMode(null);
            setEmailEditorInitialHtmlEdited(false);
            setEmailEditorInitialHtmlSnapshot(null);
            setEmailEditorInitialDynamicContent(null);
            setEmailEditorStateLoading(false);
            setEmailEditorStateError(null);
          }}
          mode="edit"
          email={emailToEdit}
          initialMjml={emailEditorInitialMjml}
          initialBuilderJson={emailEditorInitialBuilderJson}
          initialLastMode={emailEditorInitialLastMode}
          initialHtmlEdited={emailEditorInitialHtmlEdited}
          initialHtmlSnapshot={emailEditorInitialHtmlSnapshot}
          initialDynamicContent={emailEditorInitialDynamicContent}
          editorStateLoading={emailEditorStateLoading}
          editorStateError={emailEditorStateError}
          onRetryEditorState={() => {
            try {
              const editedId = (emailToEdit && emailToEdit.id) || null;
              if (!editedId) return;
              loadEmailEditorState(editedId);
            } catch (_) {}
          }}
          onContentChange={(html) => {
            try {
              const editedId = (emailToEdit && emailToEdit.id) || null;
              if (!editedId) return;
              setForm(prev => ({
                ...prev,
                selectedEmails: prev.selectedEmails.map(se => {
                  const currentId = se.mautic_email_id || se.id;
                  if (currentId === editedId) {
                    const updatedConfig = { ...(se.config || {}), customHtml: html };
                    return { ...se, config: updatedConfig };
                  }
                  return se;
                })
              }));
            } catch (_) { }
          }}
        />
      )}

      {/* Push Edit Modal (same form & endpoint as push page) */}
      <Dialog
        open={pushEditModalOpen}
        onClose={() => setPushEditModalOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden',
            height: '600px',
            maxWidth: '950px'
          }
        }}
      >
        <Box sx={{ display: 'flex', height: '100%' }}>
          {/* Left: Form */}
          <Box sx={{ flex: 1, p: 4, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h5" sx={{ fontWeight: 700, fontFamily: 'Montserrat, Arial, sans-serif' }}>Modifier la notification push</Typography>
              <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5, fontFamily: 'Montserrat, Arial, sans-serif' }}>
                Modifiez les détails de votre notification.
              </Typography>
            </Box>

            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box>
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b', textTransform: 'uppercase', mb: 0.5, display: 'block' }}>Nom / Titre <span style={{ color: 'red' }}>*</span></Typography>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="ex: Promo Janvier"
                  value={pushEditFormData.name || ''}
                  onChange={e => setPushEditFormData({ ...pushEditFormData, name: e.target.value })}
                  required
                  error={!pushEditFormData.name}
                />
                <Typography variant="caption" sx={{ color: '#64748b', fontSize: '0.7rem' }}>Ce nom sera utilisé comme titre de la notification.</Typography>
              </Box>
              <Box>
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b', textTransform: 'uppercase', mb: 0.5, display: 'block' }}>Message <span style={{ color: 'red' }}>*</span></Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  value={pushEditFormData.message}
                  onChange={e => setPushEditFormData({ ...pushEditFormData, message: e.target.value })}
                  placeholder="Contenu..."
                  required
                  error={!pushEditFormData.message}
                />
              </Box>
              <Box>
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b', textTransform: 'uppercase', mb: 0.5, display: 'block' }}>URL</Typography>
                <TextField fullWidth size="small" value={pushEditFormData.url} onChange={e => setPushEditFormData({ ...pushEditFormData, url: e.target.value })} placeholder="https://..." />
              </Box>
              <Box>
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b', textTransform: 'uppercase', mb: 0.5, display: 'block' }}>Texte Bouton d'Action</Typography>
                <TextField fullWidth size="small" value={pushEditFormData.buttonText} onChange={e => setPushEditFormData({ ...pushEditFormData, buttonText: e.target.value })} placeholder="ex: En savoir plus" />
              </Box>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3, pt: 3, borderTop: '1px solid #e2e8f0' }}>
              <Button onClick={() => setPushEditModalOpen(false)} sx={{ color: '#64748b', fontFamily: 'Montserrat, Arial, sans-serif' }}>Annuler</Button>
              <Button
                onClick={handleUpdatePushInCampaign}
                disabled={isUpdatingPush || !pushEditFormData.name || !pushEditFormData.message}
                variant="contained"
                sx={{ bgcolor: '#00808a', fontFamily: 'Montserrat, Arial, sans-serif', '&:hover': { bgcolor: '#006b73' } }}
              >
                {isUpdatingPush ? <CircularProgress size={24} color="inherit" /> : 'Enregistrer'}
              </Button>
            </Box>
          </Box>

          {/* Right: Preview */}
          <Box sx={{ width: '40%', bgcolor: '#f8fafc', borderLeft: '1px solid #e2e8f0', p: 4, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 700, textTransform: 'uppercase', mb: 3, textAlign: 'center' }}>
              Aperçu en direct
            </Typography>

            <Box sx={{
              width: '100%',
              bgcolor: '#ffffff',
              borderRadius: 2,
              p: 2,
              boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)',
              border: '1px solid #e2e8f0',
              display: 'flex',
              gap: 2
            }}>
              <Box sx={{ width: 40, height: 40, flexShrink: 0, borderRadius: 1, bgcolor: '#00808a', display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography sx={{ fontSize: '0.7rem', fontWeight: 700, color: '#64748b' }}>PushNotify</Typography>
                  <Typography sx={{ fontSize: '0.7rem', color: '#64748b' }}>maintenant</Typography>
                </Box>
                <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: '#1e293b', mb: 0.25, lineHeight: 1.2 }}>
                  {pushEditFormData.name || 'Titre de la notification'}
                </Typography>
                <Typography sx={{ fontSize: '0.8rem', color: '#475569', lineHeight: 1.4 }}>
                  {pushEditFormData.message || 'Votre message apparaîtra ici...'}
                </Typography>
                {pushEditFormData.buttonText && (
                  <Box
                    component={pushEditFormData.url ? "a" : "div"}
                    href={pushEditFormData.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      mt: 1, p: 0.75, bgcolor: '#f1f5f9', border: '1px solid #e2e8f0',
                      borderRadius: 1, textAlign: 'center', fontSize: '0.75rem', fontWeight: 600,
                      color: '#00808a', display: 'block', textDecoration: 'none',
                      cursor: pushEditFormData.url ? 'pointer' : 'default'
                    }}
                  >
                    {pushEditFormData.buttonText}
                  </Box>
                )}
              </Box>
            </Box>

            <Typography variant="caption" sx={{ textAlign: 'center', color: '#64748b', mt: 4, display: 'block' }}>
              L'apparence peut varier selon l'appareil.
            </Typography>
          </Box>
        </Box>
      </Dialog>
      {/* SMS / Social Message Edit Modal */}
      <Dialog
        open={smsEditModalOpen}
        onClose={() => setSmsEditModalOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden', height: '650px', maxWidth: '1000px' } }}
      >
        <Box sx={{ display: 'flex', height: '100%' }}>
          {/* Left: Form (aligné sur TextMessages) */}
          <Box sx={{ flex: 1, p: 4, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h5" sx={{ fontWeight: 700, fontFamily: 'Montserrat, Arial, sans-serif' }}>
                Modifier le message
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5, fontFamily: 'Montserrat, Arial, sans-serif' }}>
                Canal : {(() => {
                  const selected = smsEditFormData.category;
                  const selectedId = selected && typeof selected === 'object' ? (selected.id ?? selected._id ?? '') : selected;
                  const cat = smsCategories.find(c => String(c.id) === String(selectedId));
                  const key = String((cat?.title || cat?.name || selectedId || '')).toLowerCase();
                  return ({ facebook: '💬 Facebook', whatsapp: '📱 WhatsApp', instagram: '📸 Instagram', sms: '💬 SMS' }[key] || (cat?.title || cat?.name || String(selectedId || '')));
                })()}
              </Typography>
            </Box>

            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box>
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b', textTransform: 'uppercase', mb: 0.5, display: 'block' }}>
                  Nom <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="ex: Promo Janvier"
                  value={smsEditFormData.name}
                  onChange={e => setSmsEditFormData({ ...smsEditFormData, name: e.target.value })}
                  required
                  error={!smsEditFormData.name}
                />
              </Box>

              <Box>
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b', textTransform: 'uppercase', mb: 0.5, display: 'block' }}>
                  Catégorie <span style={{ color: 'red' }}>*</span>
                </Typography>
                <Select
                  fullWidth
                  size="small"
                    value={smsEditFormData.category}
                  onChange={e => setSmsEditFormData(prev => ({ ...prev, category: e.target.value }))}
                  displayEmpty
                  renderValue={(selected) => {
                    if (!selected) {
                      return <em style={{ color: '#6B7280', fontStyle: 'normal' }}>Sélectionner une catégorie</em>;
                    }
                    const selectedId = selected && typeof selected === 'object' ? (selected.id ?? selected._id ?? '') : selected;
                    const cat = smsCategories.find(c => String(c.id) === String(selectedId));
                    if (cat) return (cat.title || cat.name);
                    if (selected && typeof selected === 'object') return (selected.title || selected.name || String(selectedId || ''));
                    return selected;
                  }}
                >
                  <MenuItem disabled value="">
                    <em>Sélectionner une catégorie</em>
                  </MenuItem>
                  {smsCategories
                    .filter(cat => ['facebook', 'whatsapp', 'instagram', 'sms'].includes((cat.title || cat.name || '').toLowerCase()))
                    .map(cat => (
                      <MenuItem key={cat.id} value={cat.id}>
                        {cat.title || cat.name || `Catégorie ${cat.id}`}
                      </MenuItem>
                    ))}
                </Select>
              </Box>

              <Box>
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b', textTransform: 'uppercase', mb: 0.5, display: 'block' }}>
                  Message <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  size="small"
                  value={smsEditFormData.message}
                  onChange={e => setSmsEditFormData({ ...smsEditFormData, message: e.target.value })}
                  placeholder="Contenu du message..."
                  helperText="Conseil: restez concis, le message est limité en longueur."
                  required
                  error={!smsEditFormData.message}
                />
              </Box>

              {/* Sélection d'une image d'asset Mautic (optionnelle) - aligné sur TextMessages */}
              {(() => {
                const selectedCat = smsCategories.find(c => c.id === smsEditFormData.category);
                const isSms = selectedCat && (selectedCat.title || selectedCat.name || '').toLowerCase() === 'sms';

                if (!isSms) {
                  return (
                    <Box>
                      <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b', textTransform: 'uppercase', mb: 0.5, display: 'block' }}>
                        Image liée (optionnel)
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <TextField
                          value={smsSelectedAsset ? `${smsSelectedAsset.name} (ID: ${smsSelectedAsset.id})` : ''}
                          fullWidth
                          size="small"
                          InputProps={{
                            readOnly: true,
                          }}
                          placeholder="Aucune image sélectionnée"
                        />
                        <Tooltip title="Choisir une image">
                          <IconButton
                            onClick={handleOpenSmsAssetGallery}
                            sx={{
                              border: '1px solid #E5E7EB',
                              borderRadius: 1,
                              color: '#007B8A'
                            }}
                          >
                            <ImageIcon />
                          </IconButton>
                        </Tooltip>
                      </Box>
                      <Typography variant="caption" sx={{ color: '#94a3b8', display: 'block', mt: 0.5 }}>
                        Sélectionnez une image à associer à ce message. L'ID sera ajouté au titre.
                      </Typography>
                    </Box>
                  );
                }
                return null;
              })()}

              <Box>
                <FormControlLabel
                  control={
                    <Switch
                      checked={smsEditPublished}
                      onChange={e => setSmsEditPublished(e.target.checked)}
                      color="primary"
                    />
                  }
                  label="Message actif"
                />
              </Box>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3, pt: 3, borderTop: '1px solid #e2e8f0' }}>
              <Button onClick={() => setSmsEditModalOpen(false)} sx={{ color: '#64748b', fontFamily: 'Montserrat, Arial, sans-serif' }}>
                Annuler
              </Button>
              <Button
                onClick={handleUpdateSmsInCampaign}
                disabled={isUpdatingSms || !smsEditFormData.name || !smsEditFormData.message}
                variant="contained"
                sx={{ bgcolor: '#007B8A', fontFamily: 'Montserrat, Arial, sans-serif', '&:hover': { bgcolor: '#005D6B' } }}
              >
                {isUpdatingSms ? <CircularProgress size={22} color="inherit" /> : 'Enregistrer'}
              </Button>
            </Box>
          </Box>

          {/* Right: Preview avec SmsMockup, comme sur TextMessages */}
          <Box sx={{ width: '45%', bgcolor: '#f1f5f9', borderLeft: '1px solid #e2e8f0', p: 4, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <Typography
              variant="subtitle2"
              sx={{ color: '#64748b', fontWeight: 700, textTransform: 'uppercase', mb: 3, textAlign: 'center', fontSize: '0.75rem' }}
            >
              Aperçu en direct
            </Typography>
            <SmsMockup
              message={smsEditFormData.message}
              image={smsSelectedAsset?.url || smsEditImageUrl || null}
            />
            <Typography variant="caption" sx={{ textAlign: 'center', color: '#64748b', mt: 4, display: 'block' }}>
              L'apparence peut varier selon l'appareil.
            </Typography>
          </Box>
        </Box>
      </Dialog>

      {/* Galerie d'images Mautic pour lier une image au Message (aligné sur TextMessages) */}
      <Dialog
        open={smsAssetGalleryOpen}
        onClose={() => setSmsAssetGalleryOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <Box p={3}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6">Bibliothèque d'images</Typography>
            <Box display="flex" gap={1}>
              <IconButton onClick={() => setSmsAssetGalleryOpen(false)} size="small">
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>

          {smsAssetImages.length === 0 && !smsAssetGalleryLoading ? (
            <Typography color="textSecondary" textAlign="center" py={4}>
              Aucune image disponible pour l'instant.
            </Typography>
          ) : (
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
                gap: 2,
                maxHeight: 500,
                overflowY: 'auto',
                pb: 2,
              }}
              onScroll={(e) => {
                const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
                if (scrollHeight - scrollTop <= clientHeight + 50) {
                  handleLoadMoreSmsAssets();
                }
              }}
            >
              {smsAssetImages.map((asset) => (
                <Paper
                  key={asset.id}
                  elevation={smsSelectedAsset?.id === asset.id ? 6 : 2}
                  sx={{
                    cursor: 'pointer',
                    overflow: 'hidden',
                    aspectRatio: '1',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border:
                      smsSelectedAsset?.id === asset.id
                        ? '2px solid #007B8A'
                        : '1px solid #E5E7EB',
                    transition: 'all 0.2s',
                    '&:hover': {
                      boxShadow: 6,
                      transform: 'scale(1.02)',
                    },
                  }}
                  onClick={() => handleSelectSmsAsset(asset)}
                >
                  <img
                    src={asset.url}
                    alt={asset.name}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </Paper>
              ))}
            </Box>
          )}

          {smsAssetGalleryLoading && (
            <Box display="flex" justifyContent="center" py={2}>
              <CircularProgress size={30} />
            </Box>
          )}

          {!smsAssetGalleryLoading && !smsAssetGalleryHasMore && smsAssetImages.length > 0 && (
            <Typography color="textSecondary" textAlign="center" py={2} variant="caption">
              Toutes les images ont été chargées.
            </Typography>
          )}
        </Box>
      </Dialog>
    </Box>
  );
}
